/* tslint:disable:max-line-length triple-equals */
import {Location} from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import {DocumentService} from 'src/app/core/services/document.service';
import {CommonService} from 'src/app/core/services/common.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SubmissionComponent} from '../submission/submission.component';
import {MatDialog} from '@angular/material';
import {NotificationService} from 'src/app/core/services/notification.service';
import {PanelDocumentViewComponent} from '../panel-document-view/panel-document-view.component';
import {BreadcrumbsService} from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import {ToastrService} from 'ngx-toastr';
import {Message} from 'src/app/core/class/message';
import {forkJoin, Subscription} from 'rxjs';
import {SignDocumentService} from 'src/app/core/services/sign-document.service';
import {DigitalCertificateService} from 'src/app/core/services/digital-certificate.service';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {Common} from 'src/app/core/constants/common';
import {TranslateService} from '@ngx-translate/core';
import {CancelSignFlowComponent} from '../cancel-sign-flow/cancel-sign-flow.component';
import {ApprovalDocumentComponent} from '../approval-document/approval-document.component';
import {
  EnumAdjustedContents,
  EnumContractEnterpriseStatus,
  EnumContractStatus,
  EnumContractUserRole,
  EnumContractUserStatus
} from 'src/app/core/constants/contract';
import {DeclineApproveDocumentComponent} from '../decline-approve-document/decline-approve-document.component';
import {DeclineSignDocumentComponent} from '../decline-sign-document/decline-sign-document.component';
import {InitialDialogComponent} from '../initial-dialog/initial-dialog.component';
import {SignatureProcessDialogComponent} from '../signature-process-dialog/signature-process-dialog.component';
import {PermissionConfig} from 'src/app/core/constants/permission-config';
import {InitialDialogSignComponent} from '../initial-dialog-sign/initial-dialog-sign.component';
import {DeclineInitialSignComponent} from '../decline-initial-sign/decline-initial-sign.component';
import {WarningSmsContractService} from '../../../../../../core/services/warning-sms-contract.service';
import {ErrorCode} from 'src/app/core/constants/error-code';
import {
  NgxExtendedPdfViewerComponent,
  NgxExtendedPdfViewerService,
  PagesLoadedEvent,
  pdfDefaultOptions,
  PDFPrintRange
} from 'ngx-extended-pdf-viewer';
import {DeviceDetectorService} from 'ngx-device-detector';
import {SlickCarouselComponent} from 'ngx-slick-carousel';
import {SCREEN_SIZE} from 'src/app/core/constants/screen-size';
import {ResponsiveService} from 'src/app/core/services/responsive.service';
import {SignPosition} from '../../../../../../shared/models/sign-position.model';
import { NotifyWarningComponent } from 'src/app/shared/components/notify-warning/notify-warning.component';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { EnvService } from 'src/app/core/services/env.service';
import { WarningCancelSignConfirmationComponent } from '../warning-cancel-sign-confirmation/warning-cancel-sign-confirmation.component';
import { ReSignatureProcessDialogComponent } from '../re-signature-process-dialog/re-signature-process-dialog.component';
import { async } from '@angular/core/testing';
import { HttpErrorResponse } from '@angular/common/http';
import { ForwardSignDialogComponent } from 'src/app/shared/components/forward-sign-dialog/forward-sign-dialog.component';
import { AddApproverDialogComponent } from 'src/app/shared/components/add-approver-dialog/add-approver-dialog.component';
import {finalize} from 'rxjs/operators';
import {DocumentTypeService} from "../../../../../../core/services/document-type.service";
import { CreateContractMohaService } from 'src/app/core/services/create-contract-moha.service';
import * as uuid from 'uuid';
import { DocumentMohaService } from 'src/app/core/services/document-moha.service';
import { ViewPropertiesDialogComponent } from './view-properties-dialog/view-properties-dialog.component';
import { FormControl, Validators } from '@angular/forms';
import { ViewPropertiesOriginalDialogComponent } from './view-properties-original-dialog/view-properties-original-dialog.component';
import { ContractService } from 'src/app/core/services/contract.service';
import { WarningDataAuthenticationComponent} from 'src/app/shared/components/warning-data-authentication/warning-data-authentication.component';
import { SignAuthenticationPopupComponent } from '../../document/add-document-moha/sign-aunthentication-popup/sign-aunthentication-popup.component';
import { DowloadAppVContractComponent } from '../../../../../../shared/components/dowload-app-vcontract-vneid/dowload-app-vcontract-vneid.component';
import { RequestConfirmIdentityComponent } from '../../../../../../shared/components/request-confirm-identity/request-confirm-identity.component';
import { EnterIdentityVneidComponent } from '../../../../../../shared/components/enter-identity-vneid/enter-identity-vneid.component';

import { truncate } from 'fs';
import { FeatureGroup } from 'src/app/core/constants/permission';

// Jquery function for disabling radio and checkbox
declare function disableFormFields(): any;
const LIMIT_SIZE = 10485760
const FileUploadType = 1;
const FormActionType = 0;
@Component({
  selector: 'app-view-document-moha',
  templateUrl: './view-document-moha.component.html',
  styleUrls: ['./view-document-moha.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ViewDocumentMohaComponent implements OnInit, OnDestroy, AfterViewInit {

  @BlockUI() blockUI: NgBlockUI;
  isLockedEnterprise = false;
  // used to unsubscribe from the interval, when OnDestroy is called.
  private isAutoSign = false;
  private isSoftCertificateExpire = true;
  private alive: boolean;
  private interval: number;
  public language: string;
  public isShowReferencePdf = false;
  public creatorSide = false;
  public isHasUserSignApprove = false;
  public isContractCreator = false;
  public isShowSidebarButton = true;
  public isFullviewPdf = true;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public subscribeViewLandscapseService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  public listPdfSrc = {};
  public isLoadAllPdfSrc = false;
  BASE_URL = 'http://localhost:8091/api';
  disableSign: boolean;
  dataCheckVneid = {
    typeVerify: '',
    certificateNoCCCD: '',
    timeWaitShare: 60
  }
  constructor(
    private printService: NgxExtendedPdfViewerService,
    private location: Location,
    private documentMohaService: DocumentMohaService,
    private documentService: DocumentService,
    private createContractMohaService: CreateContractMohaService,
    private documentTypeService: DocumentTypeService,
    public commonService: CommonService,
    private dialog: MatDialog,
    private router: Router,
    private breadcrumbsService: BreadcrumbsService,
    public notificationService: NotificationService,
    private toastr: ToastrService,
    private message: Message,
    private route: ActivatedRoute,
    private signDocumentService: SignDocumentService,
    private digitalCertificateService: DigitalCertificateService,
    private translateService: TranslateService,
    private warningSmsContractService: WarningSmsContractService,
    public deviceService: DeviceDetectorService,
    private responsiveService: ResponsiveService,
    private env: EnvService,
    private contractService: ContractService,

  ) {
    this.id = this.route.snapshot.paramMap.get('id');
    this.permissions = localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')) : [];
    this.userId = localStorage.getItem('userId');
    this.userType = localStorage.getItem('userType');
    this.language = localStorage.getItem('__language') || 'vi';

    // set menu trái là default Collapsed khi vào màn Lập hợp đồng
    // localStorage.setItem(this.SIDEBAR_CURRENT_STATUS, this.COLLAPSED);
    this.alive = true;
    this.interval = 5000;
    pdfDefaultOptions.renderInteractiveForms = false;
    this.BASE_URL = env.is_private_app ? env.private_api_endpoint : env.public_api_endpoint;
    this.BASE_URL += '/file/view/contract'

    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
  }

  private stampWrapper: HTMLDivElement;
  private enterpriseSign: any;
  private userSignCurrent: any;
  private userSign = [];
  private userApproves = [];
  public isCancelDocument = false;
  public isSignDocument = false;
  public isShowResign = false;
  public isSignDigitalCert = false;
  public isInitialDocument = false;
  public isStartSignFlow = false;
  public isApproveDocument = false;
  public isForwarDocument = false;
  public isGotoSignPageDocument = false;
  private initialList = [];
  public warningContractQuantity = false;
  private EventWarningContractSubscription: Subscription;
  permissionContractShare: boolean = true

  @ViewChildren('focus') focus;
  @ViewChild(PanelDocumentViewComponent, {read: PanelDocumentViewComponent, static: true}) panelDocumentViewComponent;
  @ViewChild('navigation', {static: false}) navigation: ElementRef;
  @ViewChild('headerControll', {static: false}) headerControll: ElementRef;
  @ViewChild('btnView', {static: false}) private btnView: ElementRef<HTMLElement>;

  DEFAULT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-document/';
  DEFAULT_RECEIVER_ROUTER_ON_BACK_LINK = '/home-enterprise/search-document-receive/';
  SIGN_WAIT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-document-sign';
  APPOVAL_WAIT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-approval-waiting-document';
  INITIAL_WAIT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-initial-waiting-document';
  MY_DOCUMENT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-my-created-document';
  MY_RECEIVE_DOCUMENT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-my-receive-document';
  MY_DOCUMENT_MOHA_ROUTER_ON_BACK_LINK = '/home-enterprise/new-document-moha';
  MY_DOCUMENT_COMPANY_ROUTER_ON_BACK_LINK = '/home-enterprise/search-document-contract-company';
  SIGN_WAIT_ROUTER_ON_BACK_LINK_MOHA = '/home-enterprise/approved-contract-moha';
  SIGN_WAIT_ROUTER_ON_BACK_LINK_APPROVED = '/home-enterprise/document-approved-contract';
  QLHS_ON_BACK_LINK = '/home-enterprise/record-management-moha';

  notifySubscription: Subscription;
  pdfSrc: any;
  id: string;
  permissions: any;
  userId: any;
  checkStatusProgress: any;
  valueSelect: number;
  current = 0;
  flagCopy = false;
  enumContractStatus = EnumContractStatus;
  enumContractEnterpriseStatus = EnumContractEnterpriseStatus;
  documentType = 1;
  disable = false;
  userType: any;
  widthRectangle = 300;
  heightRectangle = 136.6;
  // Is type form
  documentForm = 0;
  cecaReTry: boolean = false
  expiredMoit: boolean = false
  // Is type file upload
  documentUpload = 1;

  @Input() formData: any;
  // Create or Update
  @Input() actionType = 1;

  serviceTypeName: null;

  isShowRetry = false;

  showSendContract = false;

  isOnlyView: boolean = false
  listApproverSignAcount:any = [];
  checkCTSShowImage:any = [] ;
  checkShowImage:any;
  listUserNoSign:any = [];
  selectedFileSign: any = 0;
  checkEdit = true;
  listSignNew: any = [];
  loadSign = true;
  checkTabPDF = true;
  signTextLayer = true;
  fileUploads: File[] = [];
  signSelected = null;
  currentNodeSelected = null;
  documentCodeNull = false;
  selectedNumberPage: number;
  isOnAutoNumber: boolean = false;
  maxPageCurrent;
  configAutoNumber: string;
  selectFile: any;
  listColumnVersionHistory: any[] = [];
  listDataVersionHistory: any[] = [];
  document: any = {
    id: '',
    code: '',
    name: '',
    parentId: '',
    enterpriseId: localStorage.getItem('enterpriseId'),
    documentTypeEnterpriseId: '',
    customerId: '',
    status: 0,
    filePath: '',
    description: '',
    assignUserId: 0,
    submitedTo: 0,
    submitedTime: '',
    typeId: null,
    isDeleted: true,
    jsonData: '',
    email: '',
    phone: '',
    createdBy: '',
    createdTime: '',
    updatedBy: '',
    updatedTime: '',
    finishDate: '',
    salt: '',
    documentTypeContent: '',
    expiredDate: '',
    contractAttachments: [],
    newUploadContractAttachments: [],
    isSended: false,
    serviceType: null,
    submitedToA: '',
    submitedToB: '',
    isDifferentEnterprise: false,
    signPage: 1,
    outputFilePath: null,
    mainContractAttachments: null,
    isHaveNoCreatedSide: null,  // bug 1:   Chức năng Xem thông tin hợp đồng/Văn bản: Nếu bên lập thiết lập luồng ký cho khách hàng
    contractMohaConfirmStatus: null,
    contractMohaStatus: null,
    contractMohaUuid: null,
    isTerminated : false
  };

  hasDigitalCertificateServer = false;

  documentTypeEnterprise = {
    isAutoSign: false,
    relationAutoSign: false
  };

  documentHtml: '';

  page: number;
  tab: number;
  totalPages = 0;
  pageVariable = 1;
  pageCurrent = 1;
  pageSize: number;
  routeLink: string;
  enterprise: '';
  documentTypeSearch: '';
  nameOrCode: '';
  customerName: '';
  status: '';
  serviceType: '';
  serviceTypeEntity: any;
  taxCode: '';
  createdUser: '';
  createdTimeFrom: '';
  createdTimeTo: '';
  finishDateFrom: '';
  finishDateTo: '';
  sortDirection: '';
  sortColumn: '';
  thumbnail: any = [];
  receivedTimeFrom: '';
  receivedTimeTo: '';
  signRole: any;
  nameOrEmailOrPhoneUserSign: '';
  senderName: '';
  certificateNo: ''
  contractCodeName: ''
  contractCodeParam: '';
  contractName: '';
  customer: '';
  contractEnterpriseCertificateNo: '';
  negotiate: '';
  formType: '';
  dialogRef: any;
  isConfirmVNeID: boolean = false;


  enterpriseId = localStorage.getItem('enterpriseId');

  defaultAddress = {
    cityId: null,
    districtId: null,
    wardId: null,
    enterpriseId: null,
    address: ''
  };

  defaultEnterprises = {
    id: null,
    name: '',
    enterpriseType: null,
    tenantId: 1,
    foreignName: '',
    parentId: null,
    abbreviation: '',
    taxCode: '',
    licenceDate: null,
    activeDate: null,
    phone: '',
    fax: '',
    primaryEmail: '',
    email: '',
    certificateId: null,
    certificateNo: '',
    issuedDate: null,
    issuedAt: '',
    expiryDate: null,
    accountNumber: '',
    bankName: '',
    bankBranch: '',
    representative: '',
    position: '',
    representativeCertificateId: null,
    representativeCertificateNo: '',
    representativeIssuedDate: null,
    representativeIssuedOn: '',
    status: true,
    version: null,
    birthday: null,
    sex: '',
    files: [],
    adminUser: '',
    addresses: [this.defaultAddress],
    attachments: [],
    parentName: '',
  };
  enterprises = this.defaultEnterprises;

  cities: { id: number, name: '', description: '' }[];
  districts: { id: number, cityId: number, name: '', description: '' }[];
  wards: { id: number, districtId: number, name: '', description: '' }[];
  selectedDistricts: { id: number, cityId: number, name: '', description: '' }[];
  selectedWards: { id: number, districtId: number, name: '', description: '' }[];
  shareDocumentSubscription: Subscription;
  firstEditLoaded = false;

  panelDataChangeSubscription: Subscription;
  documentTypeChangeSubscription: Subscription;

  takeInfo = null;
  typeCopy: any;
  isSetUpSignFlow: any;
  /**
   * Check document processing sign
   */
  inMultiSignProgress: false;

  isBlockSign: false;

  /**
   * Document parent name
   */
  documentParentName: string;

  zoomLevel: any = '100';
  totalPage: any;

  goFrom: string;
  breadcrumbWaitSignActive = false;

  pageIndex = 1;
  signNeedShow: any;
  signApproverNeedShow: any;

  isSelectPosition = false;
  isMouseLeave: boolean = false;
  stopDrop = true;

  isCurrentStatus: number;
  EnumContractStatus = EnumContractStatus;
  isSetupSignFlow: boolean;
  contractCode = '';
  SIDEBAR_CURRENT_STATUS = 'SidebarCurrentStatus';
  EXPANDED = 'Expanded';
  COLLAPSED = 'Collapsed';
  @ViewChildren('childFocusPreview') childFocusPreview;
  isCheckAccessToContract = true;
  authorization: any
  slideButtonConfig = {
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    autoplay: false,
    autoplaySpeed: 6000,
    focusOnSelect: false,
  };

  activeFile: number = 0;
  fileSrc: any[] = [];
  listSign: SignPosition[] = [];
  listSignature: any[] = [];
  signatureSelected = null;
  listSignatureTable: any[] = [];
  listFile: any[] = [];

  isViewLandscape: boolean = false;
  isNotAttestedUser: boolean = false;
  constPdf: any
  markPdf: any
  isEmploymentContract: boolean = false;
  isEditMode: boolean = false;
  isShowBtnViewReport: boolean = false;
  isVneidVerified: boolean = false;
  isVneidEnterpriseVerified: boolean = false;
  isContractStandardized: boolean = false;

  listDataSource: any = [];
  listDataUpdateSource: any = [];
  customerMohaId: any = null
  optionsMap = new Map<number, any[]>();
  listCustomer: any[] = [];
  isShowBtnReport: boolean = false
  titleChange: string = '';


  public enumAdjustedContents = EnumAdjustedContents;
  async ngOnInit() {
    await this.loadDataTable()
    this.authorization = {
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    }
    // get tài liệu
    await this.getDocumentById(this.id);
    const date = new Date();
    this.formData = {
      createDate: date.getDate(),
      createMonth: date.getMonth() + 1,
      createYear: date.getFullYear().toString().slice(-2)
    };

    this.registerEvents();
    this.handleBreadcrumbs();

    // Time interval for 5s
    // interval(this.interval).pipe(takeWhile(() => this.alive)).subscribe(() => {
    //   // this.getNotifies();
    // });

  }



  ngAfterViewInit() {
    setTimeout(_ => this.focus.first.nativeElement.focus());
    if (this.document.mainContractAttachments) {
      setTimeout(() => {
        const boxRight = document.getElementById('box-right');
        const boxLeft = document.getElementById('box-left');
        const boxCenter = document.getElementById('box-center');
        boxCenter.style.width = `calc(100% - ${boxRight.getBoundingClientRect().width}px - ${boxLeft.getBoundingClientRect().width}px)`;
        const tabs = document.getElementsByClassName('tab');
        if (tabs) {
          Array.from({length: tabs.length}, (v, i) => i).forEach(index => {
            const tab = tabs.item(index) as HTMLElement;
            tab.style.width = 100 / this.document.mainContractAttachments.length + '%';
          })
        }
      }, 100);
    }
    // ẩn nút toggle từ menu trái
    document.getElementById('sidebarToggle').style.display = 'none';


    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
        }
      }
    );

    this.subscribeViewLandscapseService = this.responsiveService.getView().subscribe(isLandscape => {
      this.isViewLandscape = isLandscape;
    });

    setTimeout(_ => {
      if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
        this.isShowSidebarButton = false;
      }

      this.setZoomLevel();
    });
  }

  handleBreadcrumbs(name?: string) {
    let bread;
    let fixBread;
    if (this.goFrom == 'receive') {
      fixBread = {label: 'breadcrumbs.document_breadcrumbs', url: '', params: []};
      bread = {label: 'breadcrumbs.document_search_receive', url: 'search-document-receive', params: []};
      this.routeLink = this.DEFAULT_RECEIVER_ROUTER_ON_BACK_LINK;
    } else if (this.goFrom == 'waitSign') {
      this.breadcrumbWaitSignActive = true;
      fixBread = {label: 'breadcrumbs.my_documents', url: '', params: []};
      bread = {label: 'breadcrumbs.document_search_sign', url: 'search-document-sign', params: []};
      this.routeLink = this.SIGN_WAIT_ROUTER_ON_BACK_LINK;
    } else if (this.goFrom == 'waitSign') {
      this.breadcrumbWaitSignActive = true;
      fixBread = {label: 'breadcrumbs.my_documents', url: '', params: []};
      bread = {label: 'breadcrumbs.document_search_sign', url: 'document-approved-contract', params: []};
      this.routeLink = this.SIGN_WAIT_ROUTER_ON_BACK_LINK_APPROVED;
    } else if (this.goFrom == 'waitSignMoha') {
      this.breadcrumbWaitSignActive = true;
      fixBread = {label: 'breadcrumbs.my_documents', url: '', params: []};
      bread = {label: 'breadcrumbs.approved_contract_moha', url: 'approved-contract-moha', params: []};
      this.routeLink = this.SIGN_WAIT_ROUTER_ON_BACK_LINK_MOHA;
    } else if (this.goFrom == 'qlhs') {
      fixBread = {label: 'breadcrumbs.my_documents', url: '', params: []};
      bread = {label: 'breadcrumbs.document_search', url: 'record-management-moha', params: []};
      this.routeLink = this.QLHS_ON_BACK_LINK;
    } else if (this.goFrom == 'labor_profile') {
      fixBread = { label: 'breadcrumbs.my_contracts', url: '', params: [] };
      bread = { label: 'left_menu.contract_dossier_management', url: 'record-management-moha', params: [] };
      this.routeLink = this.QLHS_ON_BACK_LINK;
    }
     else if (this.goFrom == 'waitApprove') {
      fixBread = {label: 'breadcrumbs.my_documents', url: '', params: []};
      bread = {label: 'breadcrumbs.document_search_approve', url: 'search-approval-waiting-document', params: []};
      this.routeLink = this.APPOVAL_WAIT_ROUTER_ON_BACK_LINK;
    } else if (this.goFrom == 'waitInitial') {
      fixBread = {label: 'breadcrumbs.my_documents', url: '', params: []};
      bread = {label: 'breadcrumbs.document_search_initial', url: 'search-initial-waiting-document', params: []};
      this.routeLink = this.INITIAL_WAIT_ROUTER_ON_BACK_LINK;
    } else if (this.goFrom == 'mine') {
      fixBread = {label: 'breadcrumbs.my_documents', url: '', params: []};
      bread = {label: 'breadcrumbs.document_search_mine', url: 'search-my-created-document', params: []};
      this.routeLink = this.MY_DOCUMENT_ROUTER_ON_BACK_LINK;
    } else if (this.goFrom == 'mineReceive') {
      fixBread = {label: 'breadcrumbs.my_documents', url: '', params: []};
      bread = {label: 'breadcrumbs.my_receive_document', url: 'search-my-receive-document', params: []};
      this.routeLink = this.MY_RECEIVE_DOCUMENT_ROUTER_ON_BACK_LINK;
    } else if(this.goFrom == 'negotiate'){
      fixBread = {label: 'breadcrumbs.my_documents', url: '', params: []};
      bread = {label: 'negotiate_contract.breadcrumb', url: 'search-negotiate-document', params: []};
      this.routeLink = '/home-enterprise/search-negotiate-document'
    } else if(this.goFrom == 'share'){
      fixBread = {label: 'breadcrumbs.document_breadcrumbs', url: '', params: []};
      bread = {label: 'contract_share_partner.breadcrumb', url: 'search-document-share-partner', params: []};
      this.routeLink = '/home-enterprise/search-document-share-partner'
    } else if (this.goFrom == 'standardizedContractSearch') {
      fixBread = {label: 'breadcrumbs.my_contracts', url: '', params: []};
      bread = {label: 'left_menu.add_conditions_employment', url: 'labor-contract-standardize-search', params: []};
      this.routeLink = '/home-enterprise/add-conditions-standard-employment';
    } else if (this.goFrom == 'standardizedContractEmployee') {
      fixBread = {label: 'breadcrumbs.my_contracts', url: '', params: []};
      bread = {label: 'left_menu.add_conditions_employment', url: 'labor-contract-standardize-search', params: []};
      this.routeLink = '/home-enterprise/add-conditions-standard-employees';
    } else if (this.goFrom == 'standardizedContractExecute') {
      fixBread = {label: 'breadcrumbs.my_contracts', url: '', params: []};
      bread = {label: 'left_menu.standardzing_contract', url: 'standardizing-labor-contracts', params: []};
      this.routeLink = '/home-enterprise/standardizing-labor-contracts';
    } else if (this.goFrom == 'hdld') { // cuongnm add condition
      fixBread = {label: 'breadcrumbs.my_contracts', url: '', params: []};
      bread = {label: 'breadcrumbs.labor_contract', url: 'new-document-moha', params: []};
      this.routeLink = this.MY_DOCUMENT_MOHA_ROUTER_ON_BACK_LINK;
    }  else if (this.goFrom == 'enterprise_company') {
      fixBread = {label: 'breadcrumbs.document_breadcrumbs', url: '', params: []};
      bread = {label: 'breadcrumbs.contract-company', url: 'search-document-contract-company', params: []};
      this.routeLink = this.MY_DOCUMENT_COMPANY_ROUTER_ON_BACK_LINK;
    } else if (this.goFrom == 'enterprise_company') {
      fixBread = {label: 'breadcrumbs.my_contracts', url: '', params: []};
      bread = {label: 'breadcrumbs.contract-company', url: 'contract-digitzation-moha', params: []};
      this.routeLink = this.MY_DOCUMENT_COMPANY_ROUTER_ON_BACK_LINK;
    }
    else {
      fixBread = {label: 'breadcrumbs.document_breadcrumbs', url: '', params: []};
      bread = {label: 'breadcrumbs.document_search', url: 'search-document', params: []};
      this.routeLink = this.DEFAULT_ROUTER_ON_BACK_LINK;
    }
    if(this.isOnlyView){
      this.breadcrumbsService.store([
        {label: 'breadcrumbs.home', url: 'analysis-report', params: [], highlight: false},
        {
          label: this.message.getMessage("breadcrumbs.document_view_moha") + (name ? ' ' + name : ''),
          url: 'view-document-moha/:id',
          params: [this.document.id],
          highlight: false
        },
      ]);
      return
    }

    this.breadcrumbsService.store([
      {label: 'breadcrumbs.home', url: 'analysis-report', params: []},
      fixBread,
      bread,
      {
        label: this.message.getMessage("breadcrumbs.document_view_moha") + (name ? ' ' + name : ''),
        url: 'view-document-moha/:id',
        params: [this.document.id]
      },
    ]);
  }

  getDigitalCertificateServer() {
    this.digitalCertificateService.getCertificatesWithType(0).subscribe(rs => {
      const data = rs && rs.data;
      this.hasDigitalCertificateServer = data && data.length;
    });
  }

  /**
   * Get document by id
   * @param id document id
   */
  getDocumentById(id: string) {
    if (id) {
      this.documentMohaService.getDocumentById(id).subscribe(async rs => {
        if(rs && rs.data) {
          if(rs.data.contractMohaVersionNewFields){
            this.mappingDataMFFormService(rs.data.contractDTO.formType !== 'CONTRACT_APPENDIX' ? rs.data.contractMohaFields : rs.data.contractMohaVersionNewFields, 'ADD')
          }
          if (rs.data.contractMohaStandardizedStatus && rs.data.contractMohaStandardizedStatus.statusDigitalCert === 'INVALID') {
            this.isSignDigitalCert = true
          }
          this.getDataUpdate(rs.data);
          if(rs.data.customerMohaId){
            this.customerMohaId= rs.data.customerMohaId
          }
          // isContractStandardized = true la HDLD chuan hoa
          if (rs.data.contractMohaStandardizedStatus) {
            this.isContractStandardized = true;
            this.isVneidVerified = rs.data.contractMohaStandardizedStatus.statusVneidCustomer === 'VALID';
            this.isVneidEnterpriseVerified = rs.data.contractMohaStandardizedStatus.statusVneid === 'VALID';
            this.isEditMode = rs.data.contractMohaStandardizedStatus.statusStandardized === 'WAIT';
            this.isShowBtnViewReport = rs.data.contractMohaStandardizedStatus.statusStandardized === 'WAIT' || rs.data.contractMohaStandardizedStatus.statusStandardized === 'DONE';
          } else {
            this.isContractStandardized = false;
          }
          this.isEmploymentContract = rs.data.contractDTO.isEmploymentContract;
          this.document = {
            ...rs.data.contractDTO,
            contractMohaConfirmStatus: rs.data.contractMohaConfirmStatus,
            contractMohaStatus: rs.data.contractMohaStatus,
            contractMohaUuid: rs.data.contractMohaUuid,
            contractOriginalDTO: rs.data.contractOriginalDTO,
            editProperty: rs.data.editProperty,
            contractAppendixDTOS: rs.data.contractAppendixDTOS,
            contractMohaErrorDescription: rs.data.contractMohaErrorDescription,
            isTerminated : rs.data.isTerminated
          };
        if (this.document.formType !== 'CONTRACT_APPENDIX') {
          this.getListVersionHistory(this.document.id);
        }
        this.isShowRetry = this.document.createdBy === localStorage.getItem('userId');
        this.cecaReTry = rs.data.cecaReTry;
        this.expiredMoit = rs.data.expiredMoit;
        if (rs.data.contractSignEntityList) {
          this.documentMohaService.setSignPosition(rs.data.contractSignEntityList);
        } else {
          this.documentMohaService.setSignPosition(null);
        }
        if(rs.data.contractDTO.negotiate == true){
          this.isFullviewPdf = false
        }
        if(rs.data.permissionContractShare == 'FILE' && this.goFrom == 'share'){
          this.isFullviewPdf = true
          this.permissionContractShare = false
        }
        if(rs.data.contractTerminations && rs.data.contractTerminations.length){
          this.document.contractTerminations = rs.data.contractTerminations
        }
        // console.log('rs.data: ', rs.data);
        this.isAutoSign = rs.data.isAutoSign;
        // this.isSoftCertificateExpire = rs.data.isCaSignExpire;
        this.contractCode = rs.data.contractDTO.code;
        this.handleBreadcrumbs(rs.data.contractDTO.name);
        this.creatorSide = rs.data.creatorSide;
        this.isHasUserSignApprove = (this.document.userApproves || []).some(item => item.status == EnumContractUserStatus.PROCESSING);
        this.isContractCreator = this.document.createdBy === localStorage.getItem('userId');
        this.documentTypeEnterprise = rs.data.documentTypeEnterpriseDTO;
        this.serviceTypeEntity = rs.data.serviceType;
        this.inMultiSignProgress = rs.data.inMultiSignProgress;
        this.isBlockSign = rs.data.isBlockSign;
        if(rs.data.contractDTO && rs.data.contractDTO.signPositions && !this.document.isApproved){
          if(rs.data.contractDTO.signPositions.length > 0){
            this.listSignNew = rs.data.contractDTO.signPositions;
            this.sortData(this.fileUploads,this.listSignNew)
            this.checkTabPDF = false;
          }
        }
        this.listSign = rs.data.contractDTO && rs.data.contractDTO.signPositions ? rs.data.contractDTO.signPositions.map(sign => {
          sign.positionX = sign.x;
          sign.positionY = sign.y;
          sign.widthRectangle = sign.width;
          sign.heightRectangle = sign.height;
          sign.pageIndex = sign.pageNumber;
          return sign;
        }) : [];
        this.listSignature = rs.data.contractDTO && rs.data.contractDTO.contractCodePositions ? rs.data.contractDTO.contractCodePositions.map((sign,idx) => {
          sign['id'] = `contract-code-config-${idx}`;
          sign.positionX = sign.x;
          sign.positionY = sign.y;
          sign.widthRectangle = sign.width;
          sign.heightRectangle = sign.height;
          sign.pageIndex = sign.pageNumber;
          return sign;
        }) : [];
        if (rs.data.contractDTO.signatures) {
          const sigPosition = []; // vij tri cua cac chan ky tu 1 - 5
          rs.data.contractDTO.signatures.forEach(item => {
            if (item.signature && item.signature.positions) {
              item.signature.positions.forEach(pos => {
                pos.name = item.signature && item.signature.name ? item.signature.name : null;
                sigPosition.push(pos);
              });
            }
          });
          this.listSign = this.listSign.map((item: any) => {
            const sign = sigPosition.find(sp => sp.signaturePositionId === item.signPositionId);
            if (sign) {
              item.name = sign.name ? sign.name : null;
            }
            return item;
          });
        }
        this.getListEnterpriseUserSignByDocumentId(id);

        // TODO: kiểm tra người dùng có quyền xem tài liệu không
        // this.checkConditionToView();
        this.checkPermissionSendContract();
        if (this.commonService.sidebarSubscription) {
          this.commonService.sidebarSubscription.next({
            documentId: this.id,
            creatorSide: rs.data.creatorSide,
            createdBy: rs.data.contractDTO.createdBy
          });
        }
        if (this.document.mainContractAttachments) {
          // set loading
          this.document.mainContractAttachments.forEach(item => {
            item.loading = true;
          });
          const firstFile = this.document.mainContractAttachments[0];
          this.pdfSrc = await this.viewDocumentUpload(this.document.id, firstFile.path, firstFile.fileSize);
          // this.viewDocumentsUpload(this.document.id);
          // load các file còn lại
          this.document.mainContractAttachments.forEach(file => {
            if (file.path != firstFile.path) {
              this.viewDocumentUpload(this.document.id, file.path, file.fileSize);
            }
          });

          setTimeout(() => {
            const boxRight = document.getElementById('box-right');
            const boxLeft = document.getElementById('box-left');
            const boxCenter = document.getElementById('box-center');
            boxCenter.style.width = `calc(100% - ${boxRight.getBoundingClientRect().width}px - ${boxLeft.getBoundingClientRect().width}px)`;
            const tabs = document.getElementsByClassName('tab');
            if (tabs) {
              Array.from({length: tabs.length}, (v, i) => i).forEach(index => {
                const tab = tabs.item(index) as HTMLElement;
                tab.style.width = 100 / this.document.mainContractAttachments.length + '%';
              })
            }
          }, 100);
        } else {
          this.viewDocument(this.document, rs.data.documentHtml);
        }
        } else {
          this.toastr.error(rs.message);
        }
      });
    }
  }

  uniqueById(arr) {
    const seen = new Set();
    const result = [];

    for (let i = 0; i < arr.length; i++) {
      const item = arr[i];

      if (!seen.has(item.id)) {
        seen.add(item.id);
        result.push(item);
      }
    }

    return result;
  }

  checkUserType() {
    if(this.userType == '3') {
      return false;
    }
    if(this.userType == '5') {
      return false;
    }
    return true;
  }

  async getListVersionHistory(id: string) {
    forkJoin([
      this.contractService.getListVersionHistory(id),
      this.contractService.getPropertiesForUpdate(),
      this.documentTypeService.getInfoProperties(null, false)
    ]).subscribe((response: any[]) => {
      if (!response || !response.length) {
          return;
      }
      const listVersion: any[] = response[0].data;
      let dataStandard = [
        ...response[2].data
      ]
      const configStandard = [
        {
          code: 'contractVersionName',
          name: 'Tên HĐ/PL',
          value: '',
          id: uuid.v4()
        },
        {
          code: 'contractVersionCode',
          name: 'Mã HĐ/PL',
          value: '',
          id: uuid.v4()
        },
        {
          code: 'version',
          name: 'Phiên bản',
          value: '',
          id: uuid.v4()
        },
        {
          code: 'createdTimeVersion',
          name: 'Ngày áp dụng',
          value: '',
          id: uuid.v4(),
          inputType: "DATETIME"
        },
        {
          code: 'isContractOriginal',
          name: 'Hình thức',
          value: '',
          id: uuid.v4(),
          inputType: "DROPDOWN",
          metadata: "[{\"value\":\"true\", \"name\":\"Hợp đồng\"}, {\"value\":\"false\", \"name\":\"Phụ lục\"}]"

        },
      ]
      if (response[1].data && response[1].data.length > 0) {
        response[1].data.forEach(element => {
          if (element.properties && element.properties.length > 0) {
            dataStandard = [
              ...dataStandard,
              ...element.properties
            ]
          }
        });
        dataStandard = [
          ...configStandard,
          ...this.uniqueById(dataStandard)
        ];
      }
      this.listColumnVersionHistory = [...dataStandard];
      if (listVersion) {
        this.listDataVersionHistory = this.mapFull(listVersion, dataStandard);
      }

    });

  }

  mapFull(versions, configFields) {
    return versions.map(version => {
      const fieldMap = {};

      version.contractMohaVersionFields.forEach(f => {
        fieldMap[f.key] = f.value;
      });

      const result = {};

      configFields.forEach(field => {
        const code = field.code;
        if (fieldMap[code] != null) {
          result[code] = fieldMap[code];
        } else if (version.contractMohaVersion[code] != null) {
          result[code] = version.contractMohaVersion[code];
        } else {
          result[code] = "";
        }
      });

      return result;
    });
  }

  async getDataUpdate(data) {
    const res:any = await this.contractService.getPropertiesForUpdate().toPromise();
    const listProperTies = res.data.map(content => {
      return {
        ...content,
        title: this.createContractMohaService.convertTitleContent(content.type)
      }
    })
    const dataUpdateFields = listProperTies.find(ele => ele.type === data.editProperty);
    if (dataUpdateFields) {
      this.titleChange = this.createContractMohaService.convertTitleContent(dataUpdateFields.type)
      let listProperties = this.mapDataMergeField(dataUpdateFields.properties);
      this.listDataUpdateSource = listProperties;
      this.buildOptions('UPDATE');
      if(data.contractMohaUpdateFields){
        this.mappingDataMFFormService(data.contractMohaUpdateFields, 'UPDATE')
      }
    }
  }

  setUpAprove(){

    // this.subscribeData();
    if (this.id) {
      this.createContractMohaService.isUpdateDocument = true;
      this.documentMohaService.getDocumentById(this.id).subscribe(res => {
        if (!res || !res.data || !res.data.contractDTO) {
          return;
        }
        const contract = res.data.contractDTO;
        let fileSizeUp = 0;
        contract.mainContractAttachments.forEach(element => {
          fileSizeUp = fileSizeUp + Number(element.fileSize);
        });
        this.createContractMohaService.fileSizeUp.next(fileSizeUp);
        if(this.flagCopy){
          contract.mainContractAttachments = []
        }
        if(res.data.contractTerminations && res.data.contractTerminations.length){
          contract.contractTerminations = res.data.contractTerminations
        }
        this.createContractMohaService.document.next(contract);
        this.createContractMohaService.fieldData = contract.fields ? contract.fields : null;
        this.createContractMohaService.tableModel = contract.tableModel ? contract.tableModel : null;
        if (contract.fields && contract.tableModel) {
          this.createContractMohaService.tableModel.rows = contract.tableModel.rows.map((item, index) => {
            if (!item.field) {
              item.field = contract.fields[index] ? contract.fields[index] : null;
            }
            return item;
          });
        }
        if (contract.signatures && !this.flagCopy) {
          const signatures = contract.signatures;
          if (contract.signPositions) {
            signatures.map(sign => {
              if (sign.signature && sign.signature.positions) {
                sign.signature.positions.map(pos => {
                  const signPos = contract.signPositions.find(sp => sp.signPositionId === pos.signaturePositionId);
                  if (signPos) {
                    pos.x = signPos.x;
                    pos.y = signPos.y;
                    pos.width = signPos.width;
                    pos.height = signPos.height;
                  }
                })
              }
            });
          }
          this.createContractMohaService.signatureData.next(signatures);
        }

        if (contract.contractShares) {
          let recordInternalUsers = [];
          contract.contractShares.map(item => {
            const recordInternalUser = {
              email: item.receiveEmail ? item.receiveEmail : item.email,
              name: item.receiveName ? item.receiveName : item.name,
              id: item.receiveId,
              departmentId: item.departmentId,
              status: item.status,
              errorReason: item.errorReason,
              type: item.receiveType,
              representativeId: item.representativeId,
              representativeIsActive: item.representativeIsActive,
              departmentName: item.departmentName,
              departmentCode: item.departmentCode,
            };
            recordInternalUsers.push(recordInternalUser);
          });
          this.createContractMohaService.recordsInternalUsers.next(recordInternalUsers)
        }

        this.valueSelect = contract.typeId ? contract.typeId : 0;
        this.createContractMohaService.createContractType.next(this.valueSelect);
        if (this.valueSelect === FileUploadType) {
          this.current = 2;
          this.createContractMohaService.currentStep.next(2);
        } else if (contract.filePath && !this.flagCopy) {
          this.commonService.getViewPdfForDocument(contract.id).subscribe(
            resFile => {
              if (!resFile) {
                return;
              }
              this.commonService.readFile(resFile, (pdfSrc) => {
                this.createContractMohaService.pdfSrc.next(pdfSrc);
              });
            }
          );
        }
        // if (contract.documentTypeEnterpriseId && this.valueSelect === FormActionType) {
        //   this.documentTypeService.findById(contract.documentTypeEnterpriseId).subscribe(resDC => {
        //     if (!resDC || !resDC.data) {
        //       return;
        //     }
        //     this.createContractMohaService.selectedTemplate.next(resDC.data);
        //   });
        // }
        if (contract.signPositions && !this.flagCopy ) {
          const signPositions = contract.signPositions.map(sign => {
            sign.positionX = sign.x;
            sign.positionY = sign.y;
            sign.widthRectangle = sign.width;
            sign.heightRectangle = sign.height;
            sign.pageIndex = sign.pageNumber;
            sign.signConfig = res.data.contractDTO.signConfig;
            return sign;
          });
          this.createContractMohaService.signPositions.next(signPositions);
        }
        if (contract.contractCodePositions && !this.flagCopy && this.valueSelect === 1) {
          const contractCodePositions = contract.contractCodePositions.map(sign => {
            sign.positionX = sign.x;
            sign.positionY = sign.y;
            sign.widthRectangle = sign.width;
            sign.heightRectangle = sign.height;
            sign.pageIndex = sign.pageNumber;
            return sign;
          });
          this.createContractMohaService.contractCodePositions.next(contractCodePositions);
        }
        if (this.flagCopy) {
          delete contract.filePath;
          delete contract.fileNameUpdate;
          delete contract.fileSizeUpdate;
          delete contract.documentTypeEnterpriseId;
          delete contract.signPositions;
        }
      });
    }
  }

  getListEnterpriseUserSignByDocumentId(id) {
    localStorage.removeItem('typeAllowCheck');
    localStorage.removeItem('enterprisePhoneProcessing');
    localStorage.removeItem('enterpriseNameProcessing');
    this.documentMohaService.getListEnterpriseUserSignBydocumentIdService(id).subscribe(rs => {
      if (rs.data) {
        rs.data.enterpriseSign.map(enter => {
          // trạng thái đang xử lý status = 2
          if (enter.status === 2 && enter.enterpriseId === localStorage.getItem('enterpriseId')) {
            localStorage.setItem('typeAllowCheck', enter.type);
            localStorage.setItem('enterprisePhoneProcessing', enter.enterprisePhone);
            localStorage.setItem('enterpriseNameProcessing', enter.enterpriseName);
          }
        });
        // bug 1:   Chức năng Xem thông tin hợp đồng/Văn bản: Nếu bên lập thiết lập luồng ký cho khách hàng
        this.document.isHaveNoCreatedSide = rs.data.isHaveNoCreatedSide;
        const {enterpriseSign, userSign, initial, enterpriseSignIdInFlow, userApproves,isSetUpSignFlow, userSignAll} = rs.data;
        this.isSetUpSignFlow = isSetUpSignFlow;
        // if(isSetUpSignFlow && !this.)
        // const userSignNew = rs.data && rs.data.userSignNew ?  rs.data.userSignNew : undefined

        this.enterpriseSign = enterpriseSign;
        this.userSign = userSign;
        //Kiểm tra điều kiện hiện check BBUQ
         this.userSignCurrent = this.userSign.find(e => e.userId === this.userId);
        if (this.document.status == 2 && this.userSignCurrent && (this.userSignCurrent.isSignDigitalCertificate && this.userSignCurrent.role == '2' || this.userSignCurrent.role == '1')) {
          if ((this.userType == 1 || this.userType == 2 || this.userType == 5) && this.userSignCurrent.status == 2) {
            this.checkAuthenVneid(() => this.checkTindySign())
          } else {
            this.checkTindySign();
          }
        } else if (this.document.status == 4) {
          if (this.userType == 1 || this.userType == 2) {
            if (this.isContractStandardized && !this.isVneidEnterpriseVerified) {
              this.checkAuthenVneid(() => this.callApiCheckMessageAuthenVneid())
            } else {
              this.callApiCheckMessageAuthenVneid();
            }
          } else {
            if (this.isContractStandardized && !this.isVneidVerified) {
              this.checkAuthenVneid(() => this.callApiCheckMessageAuthenVneid())
            } else {
              this.callApiCheckMessageAuthenVneid();
            }
          }

        }
        this.userApproves = userApproves;
        this.handleShowBtnReport()
        // xử lý tên cho chân ký
        if (this.listSign.length) {
          let listSignContractUserIdY = this.listSign.filter(ala =>{
            return ala.contractUserId;
          })
          let listSignContractUserIdN = this.listSign.filter(ala =>{
            return !ala.contractUserId;
          })
          if(listSignContractUserIdY.length > 0 || listSignContractUserIdN.length > 0){
            this.listSign = [];
          }
          if(listSignContractUserIdY.length > 0){
            listSignContractUserIdY.forEach((sign: any) => {
              userSignAll.forEach(ala =>{
                ala.data.forEach(ele =>{
                  if(sign.contractUserId == ele.contractUserId){
                    sign.name = ele.userName;
                  }
                })
              })
            });
            listSignContractUserIdY.forEach(ala => {
              this.listSign.push(ala)
            })
          }
          if(listSignContractUserIdN.length > 0){
            listSignContractUserIdN.forEach((sign: any) => {
              let customer;
              if (sign.enterpriseId && sign.enterpriseId.length > 0) {
                customer = enterpriseSign.find(es => es.enterpriseId === sign.enterpriseId && !es.isCreatedSide);
              } else {
                if (sign.customerId) {
                  customer = enterpriseSign.find(es => es.customerId === sign.customerId);
                }
              }
              const signer = userSign.find(res => res.userId === sign.userId && res.enterpriseSignId === sign.enterpriseId && res.role === 1);
              const approver = userSign.find(res => res.userId === sign.userId && res.enterpriseSignId === sign.enterpriseId && res.role === 2);
              if (signer && signer.isCreatedSide) {
                sign.name = signer ? signer.userName : null;
              } else if (approver && approver.isSignDigitalCertificate) {
                sign.name = approver ? approver.userName : null;
              } else if (customer) {
                sign.name = customer ? customer.enterpriseName : null;
              }
            });
            listSignContractUserIdN.forEach(ala => {
              this.listSign.push(ala)
            })
          }

        }
        const currentEnterpriseProcess = enterpriseSign.filter(item => item.enterpriseId === this.enterpriseId
          && (item.status === this.enumContractEnterpriseStatus.PROCESSING || item.status === this.enumContractEnterpriseStatus.WAIT_SETUP_FLOW));
        this.checkStatusProgress = (userSign.length === 0 && currentEnterpriseProcess.length > 0 && this.document.status == this.enumContractStatus.PROCESSING);
        if(this.checkStatusProgress){
          this.setUpAprove();
        }
        this.initialList = initial;
        if (this.panelDocumentViewComponent) {
          this.panelDocumentViewComponent.getDocumentById(this.document, this.takeInfo, this.serviceTypeEntity, enterpriseSign, userSign, userApproves, initial, enterpriseSignIdInFlow, isSetUpSignFlow, userSignAll, this.creatorSide, this.expiredMoit, this.isContractStandardized);
        }
        this.checkPermissionNewFlow();

        //Chủ thể bị khóa
        this.checkPermissionNewFlowLockedEnterprise();
        // Lay HD lien ket
        this.getDocumentRefer(id);
      }
    }, (error) => console.log(error));
  }

  callApiCheckMessageAuthenVneid() {
    this.documentMohaService.checkMessageAuthen(this.document.id).subscribe(res => {
      if (!res.data.isDoneMessageAuthen) {
        this.checkTindySign();
      }
    })
  }

  checkPermissionNewFlow() {
    // Nếu là người lập và trạng thái là PROCESSING (2) hoặc WAIT_CONFIRM_ENTERPRISE_NO_MOIT (9) thì hiển thị button Hủy luòng
    if (this.document.createdBy == this.userId && (this.document.status == EnumContractStatus.PROCESSING || this.document.status == EnumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT)) {
      this.isCancelDocument = true;
    } else {
      this.isCancelDocument = false;
    }

    if (this.document.createdBy == this.userId && this.document.status == EnumContractStatus.DRAFT) {
      this.isStartSignFlow = true;
    } else {
      this.isStartSignFlow = false;
    }

    // isSignDocument
    const listUserSignOfCurrent = this.userSign.filter(p => p.enterpriseId === this.enterpriseId);
    this.isSetupSignFlow = listUserSignOfCurrent.length === 0;
    this.userSign.forEach((item) => {

      // chỉ xét thằng user đang đăng nhập thôi
      if (item.userId == this.userId) {
        // kiểm tra quyền phê duyệt
        // tslint:disable-next-line:max-line-length
        this.isApproveDocument = item.role == EnumContractUserRole.APPROVE && item.status == EnumContractUserStatus.PROCESSING && this.document.status == EnumContractStatus.PROCESSING;
        // kiểm tra quyền ký duyệt
        this.isSignDocument = item.role == EnumContractUserRole.SIGN && item.status == EnumContractUserStatus.PROCESSING && this.document.status == EnumContractStatus.PROCESSING;
        if (this.isSignDigitalCert) {
          this.isShowResign = true;
        }
        // Check role to forward initial
        this.isForwarDocument = (this.isSignDocument || this.isApproveDocument) &&
          (this.userType == PermissionConfig.USER_ENTERPRISE_ADMIN_TYPE || this.userType == PermissionConfig.USER_ENTERPRISE_STAFF_TYPE)
          && this.document.status == EnumContractStatus.PROCESSING;

      }
    });
    // kiểm tra quyền ký nháy
    this.initialList.forEach(item => {
      if (item.userId == this.userId) {
        if (item.role == EnumContractUserRole.INITIAL && item.status == EnumContractStatus.PROCESSING
          && !(this.userId in this.initialList.map(p => p.userId))
          && this.document.status == EnumContractStatus.PROCESSING) {
          this.isInitialDocument = true;
        } else {
          this.isInitialDocument = false;
        }
      }
    });

    if (this.deviceService.isMobile() || this.deviceService.isTablet() || this.deviceService.isDesktop()) {
      this.isGotoSignPageDocument = true;
    }
  }

  checkPermissionNewFlowLockedEnterprise() {
    if (this.commonService.getIsLockedEnterprise() &&
      (this.routeLink === this.MY_DOCUMENT_ROUTER_ON_BACK_LINK ||
        // this.routeLink === this.MY_RECEIVE_DOCUMENT_ROUTER_ON_BACK_LINK ||
        this.routeLink === this.DEFAULT_ROUTER_ON_BACK_LINK ||
        this.routeLink === this.SIGN_WAIT_ROUTER_ON_BACK_LINK ||
        this.routeLink === this.APPOVAL_WAIT_ROUTER_ON_BACK_LINK ||
        this.routeLink === this.INITIAL_WAIT_ROUTER_ON_BACK_LINK)) {
      this.isLockedEnterprise = true;
      // this.isSignDocument = false;
      this.isForwarDocument = false;
      // this.isInitialDocument = false;
      this.isCancelDocument = false;
    }
  }

  /**
   *
   * @param typeId type document
   */
  viewDocument(document, htmlMerge) {
    this.viewDocumentUpload(this.document.id, this.document.filePath);
  }


  async viewDocumentUpload(contractId, pdfFilePath, size?) {
    const data: ViewDocumentReferenceDto = {
      pdfFilePath: pdfFilePath,
      mainContractId: contractId,
      referenceContractId: "",
    };
    const queryString = Object.entries(data)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
    // const res = await this.commonService.getViewPdfForDocumentByFilePath(data).toPromise();
    let pdfSrc
    if(!this.env.pdfViewFullDownload && size && size > 10485760){
      pdfSrc = `${this.BASE_URL}?${queryString}`;
      this.listPdfSrc[pdfFilePath] = pdfSrc;
      this.document.mainContractAttachments.forEach(item => {
        if (item.path == pdfFilePath) {
          item.loading = false;
        }
      });
      this.isLoadAllPdfSrc = this.document.mainContractAttachments.filter(item => {
        return item.loading
      }).length == 0;
    }else{
      const res = await this.commonService.getViewPdfForDocumentByFilePath(data).toPromise();
      pdfSrc = await this.showPdf(res, pdfFilePath);
    }

    return pdfSrc;
  }

  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return theBlob as File;
  };

  async showPdf(blob: any, pdfFilePath: string) {
    const file = this.blobToFile(blob, 'application/pdf');
    const pdfSrc = await this.commonService.readFileAsync(file);
    this.listPdfSrc[pdfFilePath] = pdfSrc;
    this.document.mainContractAttachments.forEach(item => {
      if (item.path == pdfFilePath) {
        item.loading = false;
      }
    });
    this.isLoadAllPdfSrc = this.document.mainContractAttachments.filter(item => {
      return item.loading
    }).length == 0;
    return pdfSrc;
  }

  /**
   * Get document reference
   * @param id Document id
   */
  getDocumentRefer(id) {
    // Nếu là bên lập thì lấy hợp đồng liên kết
    if (this.creatorSide) {
      return this.documentMohaService.getDocumentReferById(id).subscribe(
        rs => {
          // Case get name of document parent
          if (this.document.parentId) {
            this.documentParentName = rs.data[0].name;
          }
          if (this.panelDocumentViewComponent) {
            this.panelDocumentViewComponent.getDocumentRefer(rs.data);
          }
        }
      );
    }
  }

  /**
   * Redirect to Update link
   */
  onUpdate() {
    this.router.navigate(['/home-enterprise/update-document-moha/' + this.document.id], {queryParams: {goFrom: 'hdld'}});
  }


  openDialogSubmissionContinue(id: string, name: string, isAutoSign: boolean) {
    this.dialogRef = this.dialog.open(SubmissionComponent, {
      width: '750px',
      data: {id, name, isAutoSign}
    });
    this.dialogHandleAfterClose(this.dialogRef);
  }

  dialogHandleAfterClose(dialogRef: any) {
    if (this.stampWrapper) {
      this.stampWrapper.remove();
    }
    return dialogRef.afterClosed().subscribe((rs) => {
      if (rs) {
        this.isCurrentStatus = rs;
      }
      if (dialogRef.componentInstance.success) {
        this.onBackClick(this.isCurrentStatus);
      }
    });
  }


  openDialogCancelSignFlow(id: string) {
    const dialogWarningRef = this.dialog.open(WarningComponent, {
      width: '500px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_cancel_flow'), this.document.code, this.document.name),
      // data: `Bạn chọn hủy luồng ký kết hợp đồng ${this.document.code}-${this.document.name}. Thực hiện hủy luồng hệ thống sẽ hủy tất cả các yêu cầu phê duyệt / ký với hợp đồng được chọn, bạn chắc chắn thực hiện chức năng này?`,
    });
    dialogWarningRef.afterClosed().subscribe(rs => {
      if (rs) {
        if (id) {
          this.dialogRef = this.dialog.open(CancelSignFlowComponent, {
            width: '500px',
            data: {
              id,
              document: this.document
            }
          });
          this.dialogHandleAfterClose(this.dialogRef);
        }
      }
      // dialogWarningRef.close();
    });
  }

  /**
   * Open PDF By Browser
   */
  openPDFByBrowser(id: string) {
    if (id) {
      this.documentMohaService.downloadFileZip(id).subscribe(res => {
        if (window.top.navigator.msSaveOrOpenBlob) {
          // Store Blob in IE
          window.top.navigator.msSaveOrOpenBlob(res, this.document.name + '.zip');
        } else {
          // Store Blob in others
          const tA = document.body.appendChild(document.createElement('a'));
          tA.href = URL.createObjectURL(res);
          tA.download = this.document.code + ' - ' + this.document.name + '.zip';
          tA.style.display = 'none';
          tA.click();
          tA.parentNode.removeChild(tA);
        }
      });
    }
  }

  callApiWaterMark(){
    const currentFrame = document.getElementById('sample-iframe');
    if(currentFrame){
      currentFrame.remove()
    }
    let a = this.document.mainContractAttachments[this.activeFile].id
    this.documentMohaService.getDocWithWaterMark(this.id,a).subscribe( async (response: any) => {
      if(response){
        this.markPdf =  await this.commonService.readFileAsync(response);
      }
      // Create the Blob URL:
      const buffer = this.markPdf;
      const blob = new Blob([buffer], {
        type: 'application/pdf'
      });
      const objectURL = URL.createObjectURL(blob);

      // Create an iframe to demonstrate it:
      const iframe = document.createElement('iframe');
      iframe.id = 'sample-iframe';
      iframe.src = objectURL;
      document.body.appendChild(iframe);
      iframe.contentWindow.print();
      iframe.hidden = true
    },(err:HttpErrorResponse)=>{
      this.toastr.error(this.translateService.instant('messages.notGetPdf'))
    })
  }


  async doPrint() {
    if(this.document.status !==this.EnumContractStatus.FINISHED ||
      (this.document.isConfirmBCT==true && this.document.bctConfirmStatus !== this.EnumContractStatus.FINISHED) ||
      (this.document.status ===this.EnumContractStatus.FINISHED && this.document.contractTerminationStatus == 4)
    ){
      this.callApiWaterMark()
    }else{
      const currentFrame = document.getElementById('sample-iframe');
      if(currentFrame){
        currentFrame.remove()
      }
      // this.printService.print();
      if(this.isString(this.pdfSrc)){
        if(this.pdfSrc =='notPDF'){
          this.toastr.error(this.translateService.instant('messages.notPdf'))
          return
        }else if(this.pdfSrc.includes('file/view/contract')&&this.document.mainContractAttachments[this.activeFile].fileSize > LIMIT_SIZE){
          this.callApiWaterMark();
          return
        }
      }

      if(this.pdfSrc.byteLength == undefined||this.pdfSrc.byteLength == 0){
        this.toastr.error(this.translateService.instant('messages.errorPdf'))
        return
      }
      this.pdfSrc = this.listPdfSrc[this.document.mainContractAttachments[this.activeFile].path];
      const buffer = this.pdfSrc;
      const blob = new Blob([buffer], {
        type: 'application/pdf'
      });
      const objectURL = URL.createObjectURL(blob);

      // Create an iframe to demonstrate it:
      const iframe = document.createElement('iframe');
      iframe.id = 'sample-iframe';
      iframe.src = objectURL;
      document.body.appendChild(iframe);
      iframe.contentWindow.print();
      iframe.hidden = true
    }
  }


  tongleFullviewPdf() {
    this.isFullviewPdf = !this.isFullviewPdf;
    this.setZoomLevel();

  }

  setZoomLevel() {
    if ((this.mediaBreakpoint === SCREEN_SIZE.MD || this.mediaBreakpoint === SCREEN_SIZE.LG
      || this.mediaBreakpoint === SCREEN_SIZE.XL || this.mediaBreakpoint === SCREEN_SIZE.XXL) && this.isFullviewPdf) {
      this.zoomLevel = '100';
    } else {
      if (this.mediaBreakpoint === SCREEN_SIZE.XXL) {
        this.zoomLevel = '100';
      } else if (this.mediaBreakpoint === SCREEN_SIZE.XL || this.mediaBreakpoint === SCREEN_SIZE.LG) {
        this.zoomLevel = '75';
      } else {
        this.zoomLevel = '50';
      }
    }
  }

  /**
   * Copy document
   */
  copyDocument(id: string) {
    if (id) {
      // if (this.document.typeId === 1) {
      //   if (!this.toastr.findDuplicate(this.message.getMessage('messages.document_no_copy'), true, true)) {
      //     this.toastr.error(this.message.getMessage('messages.document_no_copy'));
      //   }
      // } else {
      this.documentMohaService.checkTemplate(this.document.id).subscribe(rs => {
        if (rs && rs.code === ErrorCode.DocumentInactive) {
          this.toastr.error(this.message.getMessage('messages.copy_contract_error_template_inactive'));
          return;
        }
        if (rs && rs.code === ErrorCode.CopyNotPermission) {
          this.toastr.error(rs.message);
          return;
        }

        this.documentMohaService.checkContractTerminationCopy(id).subscribe(res =>{
          if (res.success) {
            this.router.navigate(['/home-enterprise/update-document-moha/' + id], {
              queryParams: {
                flagCopy: true,
                typeCopy: this.typeCopy,
                page: this.page,
                pageSize: this.pageSize,
                routeLink: this.routeLink,
                enterprise: this.enterprise,
                documentType: this.documentTypeSearch,
                nameOrCode: this.nameOrCode,
                customerName: this.customerName,
                status: this.status,
                serviceType: this.serviceType,
                taxCode: this.taxCode,
                createdUser: this.createdUser,
                createdTimeFrom: this.createdTimeFrom,
                createdTimeTo: this.createdTimeTo,
                finishDateFrom: this.finishDateFrom,
                finishDateTo: this.finishDateTo,
                pageView: true,
                sortColumn: this.sortColumn,
                sortDirection: this.sortDirection
              }
            });
          } else {
            this.toastr.error(res.message)
          }
        })
      });
      // }
    }
  }

  /**
   * Back button clicking
   */
  onBackClick(isCurrentStatus?) {
    if (isCurrentStatus) {
      this.router.navigate([this.routeLink], {
        queryParams: {
          page: this.page,
          pageSize: this.pageSize,
          tab: this.tab,
          enterprise: this.enterprise,
          documentType: this.documentTypeSearch,
          nameOrCode: this.nameOrCode,
          customerName: this.customerName,
          status: this.status,
          // status: isCurrentStatus,
          serviceType: this.serviceType,
          taxCode: this.taxCode,
          createdUser: this.createdUser,
          createdTimeFrom: this.createdTimeFrom,
          createdTimeTo: this.createdTimeTo,
          finishDateFrom: this.finishDateFrom,
          finishDateTo: this.finishDateTo,
          sortColumn: this.sortColumn,
          sortDirection: this.sortDirection,
          certificateNo: this.certificateNo,
          contractCodeName: this.contractCodeName,
        }
      });
    } else {
      if (!this.routeLink || this.routeLink == '') {
        this.routeLink = this.MY_DOCUMENT_ROUTER_ON_BACK_LINK;
      }
      this.router.navigate([this.routeLink], {
        queryParams: {
          page: this.page,
          pageSize: this.pageSize,
          tab: this.tab,
          enterprise: this.enterprise,
          documentType: this.documentTypeSearch,
          nameOrCode: this.nameOrCode,
          customerName: this.customerName,
          status: this.status,
          serviceType: this.serviceType,
          taxCode: this.taxCode,
          createdUser: this.createdUser,
          createdTimeFrom: this.createdTimeFrom,
          createdTimeTo: this.createdTimeTo,
          finishDateFrom: this.finishDateFrom,
          finishDateTo: this.finishDateTo,
          sortColumn: this.sortColumn,
          sortDirection: this.sortDirection,
          receivedTimeFrom: this.receivedTimeFrom,
          receivedTimeTo: this.receivedTimeTo,
          signRole: this.signRole,
          nameOrEmailOrPhoneUserSign: this.nameOrEmailOrPhoneUserSign,
          senderName: this.senderName,
          certificateNo: this.certificateNo,
          contractCodeName: this.contractCodeName,
          contractCode: this.contractCodeParam,
          contractName: this.contractName,
          customer: this.customer,
          contractEnterpriseCertificateNo: this.contractEnterpriseCertificateNo,
          negotiate: this.negotiate,
          formType: this.formType,
        }
      });
    }
  }

  /**
   * Destroy component
   */
  ngOnDestroy() {
    const currentFrame = document.getElementById('sample-iframe');
    if(currentFrame){
      currentFrame.remove()
    }
    this.subscribeMediaBreakPointService.unsubscribe();
    this.subscribeViewLandscapseService.unsubscribe();
    if (this.EventWarningContractSubscription != null) {
      this.EventWarningContractSubscription.unsubscribe();
    }
  }


  checkAuthenVneid(callback?: () => void, isSignFlow: boolean = false) {
    this.documentMohaService.getCheckVneidConfirm(this.document.id, true, isSignFlow).subscribe(res => {
      if (res.success) {
        this.dataCheckVneid = res.data;
        switch (this.dataCheckVneid.typeVerify) {
          case 'SHARE_INFO':
            this.openRequestConfirmIdentity(callback);
            break;
          case 'FACE_MATCH':
            this.openRequestConfirmIdentity(callback);
            break;
          case 'VERIFIED':
            callback();
            break;
        }
      } else {
        this.toastr.error(res.message);
      }
    })
  }

  private openRequestConfirmIdentity(callback?: () => void): void {
    const dialogRef = this.dialog.open(RequestConfirmIdentityComponent, {
      width: this.deviceService.isMobile() ? '100%' : '640px',
      panelClass: 'scontract-overlay-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.openEnterIdentityVneid(callback);
      } else {
        if (this.location.path().includes('view-document-moha')) {
          this.location.back();
        }
      }
    });
  }

  private openEnterIdentityVneid(callback?: () => void): void {
    const dialogRef = this.dialog.open(EnterIdentityVneidComponent, {
      panelClass: 'sign-authentication',
      width: '1080px',
      maxWidth: '90vw',
      height: 'auto',
      disableClose: true,
      data: {
        documentId: this.document.id,
        dataCheckVneid: this.dataCheckVneid,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        this.openRequestConfirmIdentity(callback);
        return;
      } else {
        callback();
      }
    });
  }

  handleStartSignFlow() {
    this.checkAuthenVneid(() => this.startSignFlow(), true)
  }

  startSignFlow(): void {
    this.checkTindy(() => {
    let message = 'messages.confirm_start_flow';
    if (this.isAutoSign) {
      message = 'messages.confirm_start_flow_auto_sign';
    }

    const dialogRe = this.dialog.open(WarningComponent, {
      width: '500px',
      data: this.commonService.format(this.message.getMessage(message), this.document.name)
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (rs) {
        if (this.document.status === 1) {
          this.documentMohaService.sendStartSignFlow(this.document.id).subscribe(res => {
            this.toastr.success(this.message.getMessage('messages.start_flow_success'));
            this.document.isSended = true;
            // Use output call method onBackClick to navigate list manager document
            this.onBackClick(this.isCurrentStatus);

          });
        }
      }
    });
    this.dialogHandleAfterClose(dialogRe);
    });
  }

  /**
   * check permission for sendContract
   */
  checkPermissionSendContract() {
    const userId = String(localStorage.getItem('userId'));
    if ((this.userType === 1 || this.document.createdBy === userId || this.permissions.includes(5)) && this.document.status === 2) {
      this.showSendContract = true;
    }
  }


  handleSignPage() {
    this.checkAuthenVneid(() => this.openSignPage());
  }

  async openSignPage() {
    if(this.isEmploymentContract){
      const res = await this.documentMohaService.checkMessageAuthen(this.document.id).toPromise();
      if (!res.success) {
        this.toastr.error(res.message);
        return;
      }
      this.beginSign();
    }else{
      this.beginSign();
    }
  }


  beginSign(){
    this.disableSign = true;
    this.documentMohaService.getDocumentById(this.id).pipe(finalize(() => this.disableSign = false)).subscribe(async rs => {
      if (rs.data && (rs.data.isBlockSign === true)) {
        this.toastr.error(this.message.getMessage('messages.no_permission_on_document'))
        return
      }
      // const params = this.getParams(window.location.href);
      const dataValidate = {
        certificateNo: '',
        representDocumentNumber: '',
        taxCodeValidate: '',
      };
      if (this.userSign) {
        this.userSign.forEach(user => {
          if (user.userId === this.userId) {
            if (this.enterpriseSign) {
              this.enterpriseSign.map(enter => {
                if (enter.enterpriseId === user.enterpriseSignId) {
                  dataValidate.certificateNo = enter.certificateNo;
                  dataValidate.representDocumentNumber = enter.representDocumentNumber;
                  dataValidate.taxCodeValidate = enter.taxCode;
                }
              });
            }
          }
        });
      }
      this.documentService.setSignDataValidate(dataValidate);
      this.documentMohaService.setContractInfo(this.document);
      this.documentMohaService.setContractFileInfo(this.listPdfSrc);
      this.router.navigate(['/home-enterprise/sign-document-v2/' + this.document.id], {
        queryParams: {
          flagCopy: true,
          page: this.page,
          pageSize: this.pageSize,
          routeLink: this.routeLink,
          enterprise: this.enterprise,
          documentType: this.documentTypeSearch,
          nameOrCode: this.nameOrCode,
          customerName: this.customerName,
          status: this.status,
          serviceType: this.serviceType,
          taxCode: this.taxCode,
          createdUser: this.createdUser,
          createdTimeFrom: this.createdTimeFrom,
          createdTimeTo: this.createdTimeTo,
          finishDateFrom: this.finishDateFrom,
          finishDateTo: this.finishDateTo,
          pageView: true,
          sortColumn: this.sortColumn,
          sortDirection: this.sortDirection,
          signPage: this.document.signPage,
          goFrom: this.goFrom,
          message: ''
        }
      });
      // const dialogRe = this.dialog.open(SignMessageDialogComponent, {
      //   width: '500px',
      //   data: {
      //     reason: '',
      //     label: 'sign-message.label',
      //     cancelLabel: 'sign-message.cancelLabel',
      //     acceptLabel: 'sign-message.acceptLabel',
      //     reasonLabel: 'sign-message.reasonLabel'
      //   }
      // });
      // dialogRe.afterClosed().subscribe(response => {
      //   if (response !== false) {
      //     this.router.navigate(['/home-enterprise/sign-document/' + this.document.id], {
      //       queryParams: {
      //         flagCopy: true,
      //         page: this.page,
      //         pageSize: this.pageSize,
      //         routeLink: this.routeLink,
      //         enterprise: this.enterprise,
      //         documentType: this.documentTypeSearch,
      //         nameOrCode: this.nameOrCode,
      //         customerName: this.customerName,
      //         status: this.status,
      //         serviceType: this.serviceType,
      //         taxCode: this.taxCode,
      //         createdUser: this.createdUser,
      //         createdTimeFrom: this.createdTimeFrom,
      //         createdTimeTo: this.createdTimeTo,
      //         finishDateFrom: this.finishDateFrom,
      //         finishDateTo: this.finishDateTo,
      //         pageView: true,
      //         sortColumn: this.sortColumn,
      //         sortDirection: this.sortDirection,
      //         signPage: this.document.signPage,
      //         goFrom: this.goFrom,
      //         message: response ? response.reason : ''
      //       }
      //     });
      //   }
      // })

    })
  }

  private registerEvents() {
    // subscribe lỗi trả về từ server
    this.notificationService.subscribeErrorService();
    // reset errorCode
    this.notificationService.resetErrorCode();
    // subscribe errorCode
    this.notificationService.getErrorCode().subscribe(errorCode => {
      if (errorCode === ErrorCode.NoAccessToContracts) {
        if (this.dialogRef) {
          this.dialogRef.close();
        }
        this.isCheckAccessToContract = false;
      } else {
        this.isCheckAccessToContract = true;
      }

      if (errorCode === ErrorCode.ContractProcessed) {
        if (this.dialogRef) {
          this.dialogRef.close();
        }
        window.location.reload();
      }
    });

    this.route
      .queryParams
      .subscribe(params => {
        this.page = params.page || 0;
        this.pageSize = params.pageSize || 0;
        this.tab = params.tab !== undefined && params.tab !== null
          ? Number(params.tab)
          : null;
        this.routeLink = params.routeLink || null;
        this.enterprise = params.enterprise || null;
        this.documentTypeSearch = params.documentType || null;
        this.nameOrCode = params.nameOrCode || null;
        this.customerName = params.customerName || null;
        this.status = Common.DOCUMENT_STATUS.indexOf(params.status) === -1 ? null : params.status;
        this.serviceType = params.serviceType || null;
        this.taxCode = params.taxCode || null;
        this.createdUser = params.createdUser || null;
        this.createdTimeFrom = params.createdTimeFrom || null;
        this.createdTimeTo = params.createdTimeTo || null;
        this.finishDateFrom = params.finishDateFrom || null;
        this.finishDateTo = params.finishDateTo || null;
        this.sortColumn = params.sortColumn || null;
        this.sortDirection = params.sortDirection || null;
        this.goFrom = params.goFrom || null;
        this.typeCopy = parseInt(params.typeCopy) || null;
        this.receivedTimeFrom = params.receivedTimeFrom || null;
        this.receivedTimeTo = params.receivedTimeTo || null;
        this.signRole = parseInt(params.signRole) || null;
        this.nameOrEmailOrPhoneUserSign = params.nameOrEmailOrPhoneUserSign || null;
        this.senderName = params.senderName || null;
        this.certificateNo = params.certificateNo || null;
        this.contractCodeName = params.contractCodeName || null;
        this.contractCodeParam = params.contractCode|| null;
        this.contractName = params.contractName|| null;
        this.customer = params.customer|| null;
        this.contractEnterpriseCertificateNo = params.contractEnterpriseCertificateNo|| null;
        this.negotiate = params.negotiate || null;
        this.formType = params.formType || null;
        this.isOnlyView = params.isOnlyView || false
      });

    this.panelDocumentViewComponent.isPanelDocumentViewSuccess.asObservable().subscribe((data) => {
      this.getDocumentById(this.id);
    });

    this.panelDocumentViewComponent.isShowReferencePdf.asObservable().subscribe((data) => {
      this.isShowReferencePdf = data;
    });

    window.addEventListener('keydown', (keydownEvent) => {
      const {keyCode} = keydownEvent;
      if (keyCode == 27) {
        this.stampWrapper.remove();
        this.isSelectPosition = false;
      }
    });

    // kiểm tra xem còn hđ hay không
    this.warningSmsContractService.getDataQuantityAndWarningQuantitySmsContractOfEnterpriseByService();
    this.EventWarningContractSubscription = this.warningSmsContractService.statusUpdated.subscribe(
      (result) => {
        this.warningContractQuantity = result;
      }
    );
  }

  onMouseClickPdfViewer() {
    this.isSelectPosition = false;
  }

  afterLoadComplete(pdf): void {
    this.totalPages = pdf.numPages;
  }

  pageRendered(e) {
    if (this.thumbnail.filter(item => item.page == e.pageNumber).length == 0) {
      this.thumbnail = [
        ...this.thumbnail,
        {
          page: e.pageNumber,
          url: e.source.canvas.toDataURL(),
          isActive: false
        }
      ];

      this.thumbnail[0].isActive = true;
    }
  }
  deleteSignature(data){

  }
  showFramesNotification(signSelected, position = null, isContractCodeConfig = false) {
    const nodeOther = document.getElementById('show-frames-notification');
    if (nodeOther) {
      nodeOther.remove();
    }
    const element: any = document.getElementById(`text-pdf-layer-${signSelected.pageIndex}-${this.activeFile}`);
    const signatureWidth = signSelected.widthRectangle * this.zoomLevel / 100;
    const heightRectangle = signSelected.heightRectangle * this.zoomLevel / 100;
    const newTop = position.top ? position.top : 0
    const newLeft = position.left ? position.left : 0
    const stampNode = document.createElement('div');
    const signZoom = this.zoomLevel / 100;
    stampNode.setAttribute('id', 'show-frames-notification');
    // keo chan ky
    if (!isContractCodeConfig) {
      this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${this.signSelected && this.signSelected.name ? this.signSelected.name : null} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: red; cursor: move;`, { notification: { text: this.translateService.instant('messages.click_to_select_sign_position'), style: `position: absolute; top: -${35 * signZoom}px; left: ${(signSelected.widthRectangle / 2 - 150) * signZoom}px; color: red; width: ${300 * signZoom}px;` } });
    } else {
      // stampNode.style.whiteSpace = 'nowrap';
      stampNode.style.wordBreak = 'break-word';
      if (this.documentCodeNull && !this.isOnAutoNumber) {
        this.renderTextContent(stampNode, this.isOnAutoNumber ? this.configAutoNumber : this.message.getMessage('headertable.doc_code_required'), `font-size: ${(signSelected.fontSize ? signSelected.fontSize : 12) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; align-items: start; text-align: left; height: 100%; cursor: move;`, { contentClass: 'text-danger' });
      } else {
        this.renderTextContent(stampNode, this.isOnAutoNumber ? this.configAutoNumber : this.document.code, `font-size: ${(signSelected.fontSize ? signSelected.fontSize : 12) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; align-items: start; text-align: left; height: 100%; color: #00f; cursor: move;`);
      }

      //stampNode.style.minWidth = (300 / 10 * 3 * signZoom) + 'px';
      stampNode.style.minHeight = (136 / 10 * 3 * signZoom) + 'px';
      // stampNode.style.minWidth ='fit-content';
      stampNode.style.wordBreak = 'break-word';
    }
    stampNode.style.position = 'absolute';
    stampNode.style.background = 'rgb(0,0,0,0.2)';
    stampNode.style.left = `${newLeft}px`;
    stampNode.style.top = `${newTop}px`;
    stampNode.style.width = `${signatureWidth}px`;
    stampNode.style.height = `${heightRectangle}px`;
    stampNode.style.zIndex = '1';
    stampNode.style.border = '1px solid #999999';
    stampNode.style.lineHeight = '1.9';
    if (this.documentCodeNull && !this.isOnAutoNumber) {
      stampNode.style.color = 'red';
    } else {
      stampNode.style.color = '#00f';
    };
    if (signSelected.fontSize) {
      stampNode.style.fontSize = signSelected.fontSize;
    };
    if (signSelected.fontFamily) {
      stampNode.style.fontFamily = signSelected.fontFamily;
    } else {
      stampNode.style.fontFamily = 'Roboto';
    };
    if (signSelected.fontStyle && signSelected.fontStyle.includes('bold')) {
      stampNode.style.fontWeight = 'bold';
    }
    if (signSelected.fontStyle && signSelected.fontStyle.includes('italic')) {
      stampNode.style.fontStyle = 'italic';
    }
    if (signSelected.fontStyle && signSelected.fontStyle.includes('underline')) {
      stampNode.style.textDecoration = 'underline';
    }
    stampNode.style.padding = `${10 * signZoom}px`;
    stampNode.className = 'no-user-select';
    this.stampWrapper = stampNode;
    element.appendChild(stampNode);
  }
  getOffClose(data){
    const stopDropOld = [];
    if(data.userId == 'undefined' || !data.userId ){
      this.stopDrop = false;
    }
    else{
      this.stopDrop = true;
    }
  }
  textLayerRenderedNew(e) {
    const element = e.source.textLayerDiv;
    const pageIndex = e.source.pageNumber
    // lấy các chữ ở trang pageNumber
    let signPosition;
    let signaturePosition;
    if ((this.listSignNew && this.listSignNew.length > 0) || (this.listSignature && this.listSignature.length > 0)) {
      const files = this.document.mainContractAttachments;
      let id;
      if (files && files.length && files[this.activeFile]) {
        const file = files[this.activeFile] as any;
        id = file.id ? file.id : null;
      }
      if (this.listSignNew && this.listSignNew.length > 0) {
        signPosition = this.listSignNew.filter((item) => {
          return item.pageIndex === pageIndex && item.fileId === id && !(item.id && item.id.includes('contract-code-config-'));
        });
      }
      if (this.listSignature && this.listSignature.length > 0) {
        signaturePosition = this.listSignature.filter((item) => {
          return item.pageIndex === pageIndex && item.fileId === id && (item.id && item.id.includes('contract-code-config-'));
        });
      }
    }

    if (signPosition && signPosition.length > 0) {

      for (const position of signPosition) {

        const x = position.positionX;
        const y = position.positionY;
        const _width = position.widthRectangle;
        const _height = position.heightRectangle;
        const name = position.name;
        const id = position.enterpriseId || position.customerId;
        const userId = position.userId;
        const elWidth = element.offsetWidth;
        const elHeight = element.offsetHeight;
        const htmlNode = this.getStampWrapperNew(x, y, _width, _height, name, id, elWidth, elHeight, userId, null, null, [], false, (position.contractSignId || position.idNumber), position.row_number);
        element.appendChild(htmlNode);
        if (position.enterpriseId) {
          if (position.enterpriseId === this.signNeedShow && position.userId === this.signApproverNeedShow) {
            const node = document.getElementById(`${position.contractSignId}-sign-${this.signNeedShow}-approver-${this.signApproverNeedShow}`);
            node.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
          }
          this.signNeedShow = null;
          this.signApproverNeedShow = null;
        } else {
          if (position.customerId === this.signNeedShow && position.userId === this.signApproverNeedShow) {
            const node = document.getElementById(`${position.contractSignId}-sign-${this.signNeedShow}-approver-${this.signApproverNeedShow}`);
            node.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });

          }
          this.signNeedShow = null;
          this.signApproverNeedShow = null;
        }

      }
    }

    // Da co chu ky anh tren he thong


    element.addEventListener('mousedown', (eventMousedown) => {
      if (!this.isSelectPosition) {
        const target: HTMLElement = eventMousedown.target;
        if (target.id && target.id.includes('contract-code-config-') || target.id.includes('sign-') || (target.parentElement && target.parentElement.id && (target.parentElement.id.includes('sign-') || target.parentElement.id.includes('contract-code-config-')))) {
          const id = target.id ? target.id : target.parentElement.id;
          const indexApprover = id.indexOf('-approver-');
          const indexSign = id.indexOf('-sign-');
          const signId = id.slice(indexSign + 6, indexApprover);
          const userId = id.slice(indexApprover + 10);
          const signUuid = id.slice(0, indexSign);
          if(userId == 'undefined' || !userId){
            this.stopDrop = false;
          }
          else {
            this.stopDrop = true;
          }
          if(this.stopDrop){
            if (target.className.includes('mat-icon')) {
              this.deleteSign(signId, userId, signUuid);
              if (target.id && target.id.includes('contract-code-config-') || (target.parentElement && target.parentElement.id && target.parentElement.id.includes('contract-code-config-'))) {
                this.deleteSignature(id);
              }
              return;
            }
            this.isSelectPosition = true;
            document.body.style.userSelect = 'none';
            const files = this.document.mainContractAttachments;
            let idFile;
            if (files && files.length && files[this.activeFile]) {
              const file = files[this.activeFile] as any;
              idFile = file.id ? file.id : null;
            }
            this.signSelected = this.listSignNew.find(item => (item.enterpriseId == signId || item.customerId == signId) && item.fileId === idFile && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
            if (this.listSignNew.length) {
              if (userId !== null && userId !== undefined && userId !== 'undefined') {
                this.signSelected = this.listSignNew.find(item => {
                  return (item.enterpriseId == signId || item.customerId == signId) && item.userId === userId && item.fileId === idFile && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)
                });
              } else {
                this.signSelected = this.listSignNew.find(item => (item.enterpriseId === signId ||  item.customerId == signId) && item.fileId === idFile && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
              }
            } if (this.listSignature.length) {
              if (target.id && target.id.includes('contract-code-config-') || (target.parentElement && target.parentElement.id && target.parentElement.id.includes('contract-code-config-'))) {
                if (id !== null && id !== undefined && id !== 'undefined') {
                  this.signatureSelected = this.listSignature.find(item => item.id === id && item.fileId === idFile);
                } else {
                  this.signatureSelected = this.listSignature.find(item => item.id === id && item.fileId === idFile);
                }
              };
            }

            let idSign = (this.signSelected.contractSignId || this.signSelected.idNumber) +  '-sign-' + (this.signSelected.enterpriseId || this.signSelected.customerId) + '-approver-' + this.signSelected.userId
            let sign = document.getElementById(idSign)
            let position = {
              top: Number(sign.style.top.slice(0, -2)),
              left: Number(sign.style.left.slice(0, -2))
            }
            const node = document.getElementById(id);
            this.currentNodeSelected = node;
            if (node) {
              node.remove();
            }
            if (Object.keys(this.signSelected || {}).length) {
              this.showFramesNotification(this.signSelected, position);
            }
            if (Object.keys(this.signatureSelected || {}).length) {
              this.showFramesNotification(this.signatureSelected, true);
            }
          }
        }
      }
    });

    element.addEventListener('mouseup', (eventMouseup) => {
      for (let i = 0; i < element.childNodes.length; i++) {
        if (element.childNodes[i].nodeName == 'DIV' && element.childNodes[i]['id'] && element.childNodes[i]['id'].includes('contract-code-config-')) {
          if (this.listSignature && this.listSignature.length > 0) {
            this.listSignature.forEach((item) => {
              if (item.id == element.childNodes[i]['id']) {
                item.page === pageIndex;
              }

            });
            // this.createContractMohaService.contractCodePositions.next(this.listSignature);
          };
          if (this.listSignatureTable && this.listSignatureTable.length > 0) {
            this.listSignatureTable.forEach((item) => {
              if (item.id == element.childNodes[i]['id']) {
                item.page === pageIndex;
              }

            });
            // this.createContractMohaService.listSignatureTable.next(this.listSignatureTable);
          }
        }
      }

      if (this.isSelectPosition) {
        this.isSelectPosition = false;
        document.body.style.userSelect = 'auto';
        // xoá dòng chọn vị trí
        const framesNotification = document.getElementById('show-frames-notification');
        if (framesNotification) {
          framesNotification.remove();
        }
        const offsetParent = element.offsetParent.dataset;
        const { pageNumber } = offsetParent;
        const boundingClient = element.getBoundingClientRect();
        const { top, left } = boundingClient;
        let signatureWidth, signatureHeight, widthHeightRatio;
        widthHeightRatio = this.widthRectangle / this.heightRectangle;
        if (Object.keys(this.signSelected || {}).length) {
          signatureWidth = this.signSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signSelected.heightRectangle * this.zoomLevel / 100;
        }
        else if (Object.keys(this.signatureSelected || {}).length) {
          signatureWidth = this.signatureSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signatureSelected.heightRectangle * this.zoomLevel / 100;
        }
        let signZoom = this.zoomLevel / 100;
        let wrapperLeft = eventMouseup.clientX - signatureWidth / 2 - left;
        let wrapperTop = eventMouseup.clientY - signatureHeight / 2 - top;
        const newDiv = document.createElement('div');
        let contractSignId = this.signSelected.contractSignId || this.signSelected.idNumber
        if (Object.keys(this.signSelected || {}).length) {
          newDiv.setAttribute('id', `${contractSignId}-sign-${this.signSelected.enterpriseId || this.signSelected.customerId}-approver-${this.signSelected.userId}`);
          newDiv.style.width = `${signatureWidth}px`;
          newDiv.style.height = `${signatureHeight}px`;
          newDiv.style.fontFamily = 'Roboto';
        }
        else if (Object.keys(this.signatureSelected || {}).length) {

          newDiv.setAttribute('id', `${this.signatureSelected.id}`);
          newDiv.style.width = `${signatureWidth}px`;
          newDiv.style.height = `${signatureHeight}px`;
          if (this.signatureSelected.fontSize) {
            newDiv.style.fontSize = `${this.signatureSelected.fontSize}px`;
          }
          if (this.signatureSelected.fontFamily) {
            newDiv.style.fontFamily = this.signatureSelected.fontFamily;
          }
          if (this.signatureSelected.fontStyle && this.signatureSelected.fontStyle.includes('bold')) {
            newDiv.style.fontWeight = 'bold';
          }
          if (this.signatureSelected.fontStyle && this.signatureSelected.fontStyle.includes('italic')) {
            newDiv.style.fontStyle = 'italic';
          }
          if (this.signatureSelected.fontStyle && this.signatureSelected.fontStyle.includes('underline')) {
            newDiv.style.textDecoration = 'underline';
          }
        }
        if (wrapperLeft > 0) {
          newDiv.style.left = `${wrapperLeft}px`;
        }
        if (wrapperTop > 0) {
          newDiv.style.top = `${wrapperTop}px`;
        }
        newDiv.style.background = 'rgb(0,0,0,0.2)';
        newDiv.style.zIndex = '1';
        newDiv.style.border = '1px solid #999999';
        newDiv.style.lineHeight = '1.9';
        newDiv.style.color = '#00f';
        if (this.documentCodeNull && !this.isOnAutoNumber) {
          newDiv.style.color = 'red';
        } else {
          newDiv.style.color = '#00f';
        }
        newDiv.style.padding = `${10 * signZoom}px`;
        newDiv.style.position = 'absolute';
        newDiv.style.minWidth = `calc(300px / 10 * 3 * ${this.zoomLevel / 100})`;
        newDiv.style.minHeight = `calc(136px / 10 * 3 * ${this.zoomLevel / 100})`;
        newDiv.className = 'no-user-select';
        if (Object.keys(this.signSelected || {}).length) {
          this.getOffClose(this.signSelected);
          if(this.stopDrop){
            this.renderTextContent(newDiv, `${this.message.getMessage('signature')} ${this.signSelected.name} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
          }
          else {
            this.renderTextContent(newDiv, `${this.message.getMessage('signature')} ${this.signSelected.name}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; height: 100%; color: #00f; cursor: move;`);
          }
        }
        else if (Object.keys(this.signatureSelected || {}).length) {
          // newDiv.style.whiteSpace = 'nowrap';
          // newDiv.style.minWidth ='fit-content';
          newDiv.style.wordBreak = 'break-word';

          if (this.documentCodeNull && !this.isOnAutoNumber) {
            this.renderTextContent(newDiv, this.isOnAutoNumber ? this.configAutoNumber : this.message.getMessage('headertable.doc_code_required'), `font-size: ${(this.signatureSelected.fontSize ? this.signatureSelected.fontSize : 12) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; align-items: start; text-align: left; height: 100%; cursor: move;`, { closeIconSize: 30 * signZoom, contentClass: 'text-danger' });
          } else {
            this.renderTextContent(newDiv, this.isOnAutoNumber ? this.configAutoNumber : this.document.code, `font-size: ${(this.signatureSelected.fontSize ? this.signatureSelected.fontSize : 12) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; align-items: start; text-align: left; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
          }
        }
        this.changeDataToTable()
        //         Thay dổi kích thước chân ký
        const resizer = document.createElement('div');
        if(this.stopDrop){
          resizer.setAttribute('class', 'resize-div-bot-right');
        }
        // resizer.setAttribute('class', 'resize-div-bot-right');
        resizer.style.setProperty('--zoom', (signZoom).toString());
        newDiv.appendChild(resizer);
        element.appendChild(newDiv);

        let startX, startY;
        let signId;
        let indexApprover;
        let userId;
        let idSignature;
        let signUuid;

        resizer.addEventListener('mousedown', (e) => {
          e.stopPropagation();
          startX = e.clientX;
          startY = e.clientY;
          document.documentElement.addEventListener('mousemove', doDrag);
          document.documentElement.addEventListener('mouseup', stopDrag);
          const targetSignId = e.target as Element;
          if (targetSignId.parentElement.id && targetSignId.parentElement.id.includes('contract-code-config-')) {
            idSignature = targetSignId.parentElement.id;
          }

          indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
          const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
          signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
          userId = targetSignId.parentElement.id.slice(indexApprover + 10);
          signUuid = targetSignId.parentElement.id.slice(0, indexSign);
        });

        // const signSelected = this.listSign.filter(item => item.enterpriseId === signId);

        let baseWidth = newDiv.offsetWidth;
        let baseHeight = newDiv.offsetHeight;

        const rerenderSign = () => {
          let signSelected, signatureSelected;
          if (this.listSignNew.length) {
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSignNew.filter(item => (item.enterpriseId === signId || item.customerId === signId) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            } else {
              signSelected = this.listSignNew.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            }
          } if (this.listSignature.length) {
            if (idSignature) {
              signatureSelected = this.listSignature.filter(item => item.id === idSignature);
            }
          }
          if (Object.keys(signSelected || {}).length && !Object.keys(signatureSelected || {}).length) {
            this.getOffClose(signSelected[0]);
            if(this.stopDrop){
              this.renderTextContent(newDiv, `${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${signSelected[0].row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
            }
            else {
              this.renderTextContent(newDiv, `${this.message.getMessage('signature')} ${signSelected[0].name}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; height: 100%; color: #00f; cursor: move;`);
            }
          } else if (Object.keys(this.signatureSelected || {}).length) {
            // newDiv.style.whiteSpace = 'nowrap';
            // newDiv.style.minWidth ='fit-content';
            newDiv.style.wordBreak = 'break-word';
            this.renderTextContent(newDiv, this.isOnAutoNumber ? this.configAutoNumber : this.document.code, `font-size: ${(this.signatureSelected.fontSize ? this.signatureSelected.fontSize : 12) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; align-items: start; text-align: left; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
          }

          newDiv.appendChild(resizer);
          resizer.style.removeProperty('--zoom');
          resizer.style.setProperty('--zoom', (signZoom).toString());
          return;
        }

        const doDrag = (e) => {
          e.stopPropagation();
          let signSelected, signatureSelected;
          if (this.listSignNew.length) {
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSignNew.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            } else {
              signSelected = this.listSignNew.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            };
          }
          if (this.listSignature.length) {
            if (idSignature) {
              signatureSelected = this.listSignature.filter(item => item.id === idSignature);
            }
          }
          if (Object.keys(signSelected || {}).length && !Object.keys(signatureSelected || {}).length) {
            signatureWidth = signSelected[0].widthRectangle * this.zoomLevel / 100;
            signatureHeight = signSelected[0].heightRectangle * this.zoomLevel / 100;
            newDiv.style.width = (signatureWidth + e.clientX - startX) + 'px';
            newDiv.style.height = (signatureHeight + e.clientY - startY) + 'px';
            let widthHeightRatio_Drag = newDiv.offsetWidth / newDiv.offsetHeight;
            if (widthHeightRatio !== widthHeightRatio_Drag) {
              newDiv.style.height = (newDiv.offsetWidth / widthHeightRatio) + 'px';
              newDiv.style.width = (newDiv.offsetHeight * widthHeightRatio) + 'px';
            }
          } else if (Object.keys(signatureSelected || {}).length) {
            signatureWidth = signatureSelected[0].widthRectangle * this.zoomLevel / 100;
            signatureHeight = signatureSelected[0].heightRectangle * this.zoomLevel / 100;
            newDiv.style.width = (signatureWidth + e.clientX - startX) + 'px';
            newDiv.style.height = (signatureHeight + e.clientY - startY) + 'px';
          }

          newDiv.style.maxWidth = (element.offsetWidth - wrapperLeft) + 'px';
          newDiv.style.maxHeight = (element.offsetHeight - wrapperTop) + 'px';
          rerenderSign();
        }

        const stopDrag = (e) => {
          e.stopPropagation();
          if (newDiv.offsetWidth / 2 + wrapperLeft < 0 || newDiv.offsetHeight / 2 + wrapperTop < 0) {
            newDiv.style.width = baseWidth + 'px';
            newDiv.style.height = baseHeight + 'px';
          } else {
            baseWidth = newDiv.offsetWidth;
            baseHeight = newDiv.offsetHeight;
          }
          rerenderSign();
          if (this.listSignNew.length) {
            this.listSignNew.forEach(item => {
              if ((item.enterpriseId === signId || item.customerId === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId))) {
                item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
                item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
              }
            });
            // this.createContractMohaService.signPositions.next(this.listSign);
          }

          if (this.listSignature.length) {
            this.listSignature.forEach(item => {
              if (item.id === idSignature) {
                item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
                item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
              }
            });
            // this.createContractMohaService.contractCodePositions.next(this.listSignature);
          }
          document.documentElement.removeEventListener('mousemove', doDrag);
          document.documentElement.removeEventListener('mouseup', stopDrag);
        }

        const zoomLevel = this.zoomLevel;
        const files = this.document.mainContractAttachments;
        let id;
        if (files && files.length && files[this.activeFile]) {
          const file = files[this.activeFile] as any;
          id = file.id ? file.id : null;
        }
        if (this.listSignNew.length && Object.keys(this.signSelected || {}).length) {
          this.listSignNew.forEach(item => {
            if (((item.enterpriseId === this.signSelected.enterpriseId && this.signSelected.enterpriseId) ||
                (item.customerId === this.signSelected.customerId && this.signSelected.customerId)) &&
              item.userId === this.signSelected.userId && item.fileId === id  &&
              ((item.contractSignId && this.signSelected.contractSignId === item.contractSignId) || (this.signSelected.idNumber === item.idNumber && item.idNumber))) {


              item.stampPositionLeft = eventMouseup.clientX - signatureWidth / 2 - left;
              item.stampPositionTop = eventMouseup.clientY - signatureHeight / 2 - top;
              item.positionX = 100 * wrapperLeft / zoomLevel;
              item.positionY = 100 * wrapperTop / zoomLevel;
              item.pageIndex = pageIndex;
              item.zoom = this.zoomLevel / 100;
              item.pdfSrc = this.pdfSrc;
              item.pageNumber = pageNumber;
              item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
              item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
            }
          });
          this.signSelected = null;
          // this.createContractMohaService.signPositions.next(this.listSign);
        }
        if (this.listSignature.length && Object.keys(this.signatureSelected || {}).length) {
          this.listSignature.forEach((item, idx) => {
            if (item.id === this.signatureSelected.id && item.fileId === id) {
              item.stampPositionLeft = eventMouseup.clientX - signatureWidth / 2 - left;
              item.stampPositionTop = eventMouseup.clientY - signatureHeight / 2 - top;
              item.positionX = 100 * wrapperLeft / zoomLevel;
              item.positionY = 100 * wrapperTop / zoomLevel;
              item.pageIndex = pageIndex;
              item.zoom = this.zoomLevel / 100;
              item.pdfSrc = this.pdfSrc;
              item.pageNumber = pageNumber;
              item.page = pageIndex;
              item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
              item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
              this.listSignatureTable[idx].page = pageIndex;
            }
          });
          this.signatureSelected = null;
          // this.createContractMohaService.contractCodePositions.next(this.listSignature);
          // this.createContractMohaService.listSignatureTable.next(this.listSignatureTable);
        }
      }
      this.changeDataToTable()
    })
    element.addEventListener('click', (clickEvent) => {
      if (!this.isSelectPosition) {
        const target: HTMLElement = clickEvent.target;
        if (target.id && target.id.includes('contract-code-config-') || target.id.includes('sign-') || (target.parentElement && target.parentElement.id && (target.parentElement.id.includes('sign-') || target.parentElement.id.includes('contract-code-config-')))) {
          const id = target.id ? target.id : target.parentElement.id;
          // const indexApprover = id.indexOf('-approver-');
          // const signId = id.slice(5, indexApprover);
          // const userId = id.slice(indexApprover + 10);
          const indexApprover = id.indexOf('-approver-');
          const indexSign = id.indexOf('-sign-');
          const signId = id.slice(indexSign + 6, indexApprover);
          const userId = id.slice(indexApprover + 10);
          const signUuid = id.slice(0, indexSign); // todo


          if (target.className.includes('mat-icon')) {
            this.deleteSign(signId, userId, signUuid);
            if (target.id && target.id.includes('contract-code-config-') || (target.parentElement && target.parentElement.id && target.parentElement.id.includes('contract-code-config-'))) {
              this.deleteSignature(id);
            }
            return;
          }
        }
      }
    });
    element.addEventListener('mouseleave', (mouseoverEvent) => {
      this.isMouseLeave = true;
      if (this.isSelectPosition) {
        const nodeOther = document.getElementById('show-frames-notification');
        if (nodeOther) {
          nodeOther.remove();
        }
      }
    });
    element.addEventListener('mouseover', () => {
      this.isMouseLeave = false;
    });
    element.addEventListener('wheel', (wheelEvent) => {
      if (this.isSelectPosition) {
        let node = element.querySelector('#show-frames-notification');
        const nodeOther = document.getElementById('show-frames-notification');
        if (!node && nodeOther) {
          nodeOther.remove();
        }
        const boundingClient = element.getBoundingClientRect();
        const { top, left } = boundingClient;
        let signatureWidth, signatureHeight;
        if (Object.keys(this.signSelected || {}).length && !Object.keys(this.signatureSelected || {}).length) {
          signatureWidth = this.signSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signSelected.heightRectangle * this.zoomLevel / 100;
        }
        else if (Object.keys(this.signatureSelected || {}).length) {
          signatureWidth = this.signatureSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signatureSelected.heightRectangle * this.zoomLevel / 100;
        }

        let signZoom = this.zoomLevel / 100;
        const widthHeightRatio = this.widthRectangle / this.heightRectangle;
        if (!node) {
          const stampNode = document.createElement('div');
          this.getOffClose(this.signSelected);
          if (Object.keys(this.signSelected || {}).length && !Object.keys(this.signatureSelected || {}).length) {
            if(this.stopDrop){
              this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${this.signSelected && this.signSelected.name ? this.signSelected.name : null} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`, { notification: { text: this.translateService.instant('messages.click_to_select_sign_position'), style: `position: absolute; top: -${35 * signZoom}px; left: ${(this.signSelected.widthRectangle / 2 - 150) * signZoom}px; color: red; width: ${300 * signZoom}px;` } });
              stampNode.style.width = `${signatureWidth}px`;
              stampNode.style.height = `${signatureHeight}px`;
            }
            else {
              this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${this.signSelected && this.signSelected.name ? this.signSelected.name : null}`, '', { notification: { text: this.translateService.instant('messages.click_to_select_sign_position'), style: `position: absolute; top: -${35 * signZoom}px; left: ${(this.signSelected.widthRectangle / 2 - 150) * signZoom}px; color: red; width: ${300 * signZoom}px;` } });
              stampNode.style.width = `${signatureWidth}px`;
              stampNode.style.height = `${signatureHeight}px`;
            }

          } else if (Object.keys(this.signatureSelected || {}).length) {
            // stampNode.style.whiteSpace = 'nowrap';
            // stampNode.style.minWidth ='fit-content';
            stampNode.style.wordBreak = 'break-word';
            this.renderTextContent(stampNode, this.isOnAutoNumber ? this.configAutoNumber : this.document.code, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: move;`, { notification: { text: this.currentNodeSelected ? '' : this.translateService.instant('messages.click_to_select_sign_position'), style: `position: absolute; top: -${35 * signZoom}px; left: ${(this.signatureSelected.widthRectangle / 2 - 150) * signZoom}px; color: red; width: ${300 * signZoom}px;` } });
          }
          this.stampWrapper = stampNode;
          stampNode.style.width = `${signatureWidth}px`;
          stampNode.style.height = `${signatureHeight}px`;
          stampNode.style.position = 'absolute';
          stampNode.setAttribute('id', 'show-frames-notification');
          stampNode.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
          stampNode.style.top = `${(wheelEvent.clientY - signatureHeight / 2 - top)}px`;
          stampNode.style.zIndex = '1';
          stampNode.style.background = 'rgb(0,0,0,0.2)';
          stampNode.style.border = '1px solid';
          stampNode.style.lineHeight = '1.9';
          stampNode.style.color = '#00f';
          stampNode.style.fontFamily = 'Roboto';
          stampNode.style.padding = `${10 * this.zoomLevel / 100}px`;
          stampNode.style.minWidth = `calc(300px / 10 * 3 * ${this.zoomLevel / 100})`;
          stampNode.style.minHeight = `calc(136px / 10 * 3 * ${this.zoomLevel / 100})`;
          stampNode.className = 'no-user-select';
          //         Thay dổi kích thước chân ký
          const resizer = document.createElement('div');
          if(this.stopDrop){
            resizer.setAttribute('class', 'resize-div-bot-right');
          }
          // resizer.setAttribute('class', 'resize-div-bot-right');
          resizer.style.setProperty('--zoom', (signZoom).toString());
          stampNode.appendChild(resizer);
          element.appendChild(stampNode);

          let startX;
          let startY;
          let signId;
          let indexApprover;
          let userId;
          let idSignature;
          let signUuid;
          resizer.addEventListener('mousedown', (e) => {
            e.stopPropagation();
            startX = e.clientX;
            startY = e.clientY;
            document.documentElement.addEventListener('mousemove', doDrag);
            document.documentElement.addEventListener('mouseup', stopDrag);
            const targetSignId = e.target as Element;
            if (targetSignId.parentElement.id && targetSignId.parentElement.id.includes('contract-code-config-')) {
              idSignature = targetSignId.parentElement.id;
            }
            // indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
            // signId = targetSignId.parentElement.id.slice(5, indexApprover);
            // userId = targetSignId.parentElement.id.slice(indexApprover + 10);

            indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
            const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
            signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
            userId = targetSignId.parentElement.id.slice(indexApprover + 10);
            signUuid = targetSignId.parentElement.id.slice(0, indexSign);
          });

          let baseWidth = stampNode.offsetWidth;
          let baseHeight = stampNode.offsetHeight;

          const rerenderSign = () => {
            let signSelected, signatureSelected;
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSignNew.filter(item => (item.enterpriseId === signId || item.customerId === signId ) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
            } else {
              signSelected = this.listSignNew.filter(item => (item.enterpriseId === signId || item.customerId === signId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)));
            };
            if (idSignature) {
              signatureSelected = this.listSignature.filter(item => item.id === idSignature);
            }
            if (Object.keys(this.signSelected || {}).length && !Object.keys(this.signatureSelected || {}).length) {
              this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${this.signSelected[0].row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
            } else if (Object.keys(this.signatureSelected || {}).length) {
              // stampNode.style.whiteSpace = 'nowrap';
              // stampNode.style.minWidth ='fit-content';
              stampNode.style.wordBreak = 'break-word';
              this.renderTextContent(stampNode, this.isOnAutoNumber ? this.configAutoNumber : this.document.code, `font-size: ${(this.signatureSelected.fontSize ? this.signatureSelected.fontSize : 12) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
            }

            stampNode.appendChild(resizer);
            resizer.style.removeProperty('--zoom');
            resizer.style.setProperty('--zoom', (signZoom).toString());
            return;
          }

          const doDrag = (e) => {
            e.stopPropagation();
            let signSelected, signatureSelected;
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSignNew.filter(item => (item.enterpriseId === signId || item.customerId === signId ) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
            } else {
              signSelected = this.listSignNew.filter(item => (item.enterpriseId === signId || item.customerId === signId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)));
            }
            if (idSignature) {
              signatureSelected = this.listSignature.filter(item => item.id === idSignature);
            }
            if (Object.keys(this.signSelected || {}).length && !Object.keys(this.signatureSelected || {}).length) {
              signatureHeight = signSelected[0].heightRectangle * this.zoomLevel / 100;
              signatureWidth = signSelected[0].widthRectangle * this.zoomLevel / 100;
            } else if (Object.keys(this.signatureSelected || {}).length) {
              signatureHeight = signatureSelected[0].heightRectangle * this.zoomLevel / 100;
              signatureWidth = signatureSelected[0].widthRectangle * this.zoomLevel / 100;
            }

            stampNode.style.width = (signatureWidth + e.clientX - startX) + 'px';
            stampNode.style.height = (signatureWidth + e.clientY - startY) + 'px';
            stampNode.style.maxWidth = (element.offsetWidth - stampNode.offsetLeft) + 'px';
            stampNode.style.maxHeight = (element.offsetHeight - stampNode.offsetTop) + 'px';
            rerenderSign();
          }

          const stopDrag = (e) => {
            e.stopPropagation();
            if (stampNode.offsetWidth / 2 + stampNode.offsetLeft < 0 || stampNode.offsetHeight / 2 + stampNode.offsetTop < 0) {
              stampNode.style.width = baseWidth + 'px';
              stampNode.style.height = baseHeight + 'px';
            } else {
              baseWidth = stampNode.offsetWidth;
              baseHeight = stampNode.offsetHeight;
            }

            rerenderSign();
            if (this.listSignNew.length) {
              this.listSignNew.forEach(item => {
                if ((item.enterpriseId === signId || item.customerId === signId ) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)) {
                  item.widthRectangle = stampNode.offsetWidth * 100 / this.zoomLevel;
                  item.heightRectangle = stampNode.offsetHeight * 100 / this.zoomLevel;
                }
              });
              // this.createContractMohaService.signPositions.next(this.listSign);
            }
            if (this.listSignature.length) {
              this.listSignature.forEach(item => {
                if (item.id == idSignature) {
                  item.widthRectangle = stampNode.offsetWidth * 100 / this.zoomLevel;
                  item.heightRectangle = stampNode.offsetHeight * 100 / this.zoomLevel;
                }
              });
              // this.createContractMohaService.contractCodePositions.next(this.listSignature);
            }

            document.documentElement.removeEventListener('mousemove', doDrag);
            document.documentElement.removeEventListener('mouseup', stopDrag);
          }

          element.appendChild(stampNode);
        } else {
          node.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
          node.style.top = `${(wheelEvent.clientY - signatureHeight / 2 - top)}px`;
        }
      }
    });
    element.addEventListener('mousemove', (mousemoveEvent) => {
      if (this.isSelectPosition && this.stopDrop) {
        // xoá dòng chọn vị trí
        const node = element.querySelector('#show-frames-notification');
        const nodeOther = document.getElementById('show-frames-notification');
        if (!node && nodeOther) {
          nodeOther.remove();
        }
        const boundingClient = element.getBoundingClientRect();
        const { top, left } = boundingClient;
        let signatureWidth, signatureHeight;
        if (Object.keys(this.signSelected || {}).length && !Object.keys(this.signatureSelected || {}).length) {
          signatureWidth = this.signSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signSelected.heightRectangle * this.zoomLevel / 100;
        } else if (Object.keys(this.signatureSelected || {}).length) {
          signatureWidth = this.signatureSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signatureSelected.heightRectangle * this.zoomLevel / 100;
        }

        let signZoom = this.zoomLevel / 100;
        if (!node) {
          const stampNode = document.createElement('div');
          if (Object.keys(this.signSelected || {}).length && !Object.keys(this.signatureSelected || {}).length) {
            this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${this.signSelected && this.signSelected.name ? this.signSelected.name : null} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: red; cursor: move;`, { notification: { text: '', style: `position: absolute; top: -${35 * signZoom}px; left: ${(this.signSelected.widthRectangle / 2 - 150) * signZoom}px; color: red; width: ${300 * signZoom}px;` } });
          } else if (Object.keys(this.signatureSelected || {}).length) {
            // stampNode.style.whiteSpace = 'nowrap';
            // stampNode.style.minWidth ='fit-content';

            stampNode.style.wordBreak = 'break-word';
            if (this.documentCodeNull && !this.isOnAutoNumber) {
              this.renderTextContent(stampNode, this.isOnAutoNumber ? this.configAutoNumber : this.message.getMessage('headertable.doc_code_required'), `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; cursor: move;`, { contentClass: 'text-danger' });
            } else {
              this.renderTextContent(stampNode, this.isOnAutoNumber ? this.configAutoNumber : this.document.code, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; color: #00f; height: 100%; cursor: move;`);
            }

          }
          stampNode.style.width = `${signatureWidth}px`;
          stampNode.style.height = `${signatureHeight}px`;
          stampNode.style.position = 'absolute';
          stampNode.setAttribute('id', 'show-frames-notification');
          stampNode.style.left = `${(mousemoveEvent.clientX - signatureWidth / 2 - left)}px`;
          stampNode.style.top = `${(mousemoveEvent.clientY - signatureHeight / 2 - top)}px`;
          stampNode.style.zIndex = '1';
          stampNode.style.background = 'rgb(0,0,0,0.2)';
          stampNode.style.border = '1px solid';
          stampNode.style.lineHeight = '1.9';
          if (this.documentCodeNull && !this.isOnAutoNumber) {
            stampNode.style.color = 'red';
          } else {
            stampNode.style.color = '#00f';
          }
          stampNode.style.fontFamily = 'Roboto';
          stampNode.style.padding = `${10 * signZoom}px`;
          stampNode.className = 'no-user-select';

          element.appendChild(stampNode);

        } else {
          node.style.left = `${(mousemoveEvent.clientX - signatureWidth / 2 - left)}px`;
          node.style.top = `${(mousemoveEvent.clientY - signatureHeight / 2 - top)}px`;
        }
      }
    });
    element.style.opacity = '1';
    element.setAttribute('id', `text-pdf-layer-${pageIndex}-${this.activeFile}`);
    this.maxPageCurrent = pageIndex;
    this.changeDataToTable();
    setTimeout(() => {
      this.changeDataToTable();
    }, 200);
  }
  textLayerRendered(e) {
    const element = e.source.textLayerDiv;
    const pageIndex = e.source.pageNumber;
    // lấy các chữ ở trang pageNumber
    if (this.document.status === EnumContractStatus.DRAFT) {
      let signPosition, signaturePosition;
        if (this.listSign && this.listSign.length > 0) {
          const files = this.document.mainContractAttachments ? this.document.mainContractAttachments : null;
          let id;
          if (files && files.length && files[this.activeFile]) {
            const file = files[this.activeFile] as any;
            id = file.id ? file.id : null;
          }
          signPosition = this.listSign.filter((item: any) => {
            return item.pageIndex === pageIndex && item.fileId === id;
          });
        }
      if (signPosition && signPosition.length > 0) {
        for (const position of signPosition) {
          const x = position.positionX;
          const y = position.positionY;
          const _width = position.widthRectangle;
          const _height = position.heightRectangle;
          const name = position.name;
          const id = position.enterpriseId;
          const userId = position.userId;
          const htmlNode = this.getStampWrapper(x, y, _width, _height, name, id, userId);
          element.appendChild(htmlNode);
        }
      }
      //
      if (this.listSignature && this.listSignature.length > 0) {
        const files = this.document.mainContractAttachments ? this.document.mainContractAttachments : null;
        let id;
        if (files && files.length && files[this.activeFile]) {
          const file = files[this.activeFile] as any;
          id = file.id ? file.id : null;
        }
        signaturePosition = this.listSignature.filter((item: any) => {
          return item.pageIndex === pageIndex && item.fileId === id;
        });
      }
      if (signaturePosition && signaturePosition.length > 0) {
        for (const position of signaturePosition) {
          const x = position.positionX;
          const y = position.positionY;
          const _width = position.widthRectangle;
          const _height = position.heightRectangle;
          const id = position.id;
          const name = this.document.code;
          const fontSize = position.fontSize;
          const fontFamily = position.fontFamily;
          const fontStyle = position.fontStyle;
          const htmlNode = this.getStampWrapper(x, y, _width, _height, name, id, 0, fontSize, fontFamily, fontStyle, true);
          element.appendChild(htmlNode);
        }
      }
    }
    element.style.opacity = '1';
    element.setAttribute('id', `text-pdf-layer-${pageIndex}`);
    this.signTextLayer = false;
  }

  handleOpenDialogApprovalDocument() {
    if (this.document.status == 2 && this.userSignCurrent && this.userSignCurrent.isSignDigitalCertificate) {
      this.checkAuthenVneid(() => this.openDialogApprovalDocument());
    } else {
      this.openDialogApprovalDocument()
    }
  }

  async openDialogApprovalDocument() {
    const userId = localStorage.getItem('userId');
    const approver = this.userSign.find(res => res.userId === userId);
    if (approver.isSignDigitalCertificate) {
      if (this.isEmploymentContract) {
        const res = await this.documentMohaService.checkMessageAuthen(this.document.id).toPromise();
        if (!res.success) {
          this.toastr.error(res.message);
          return;
        }
      }
      this.documentMohaService.setContractInfo(this.document);
      this.documentMohaService.setContractFileInfo(this.listPdfSrc);
      this.router.navigate(['/home-enterprise/sign-document-v2/' + this.document.id], {
        queryParams: {
          flagCopy: true,
          page: this.page,
          pageSize: this.pageSize,
          routeLink: this.routeLink,
          enterprise: this.enterprise,
          documentType: this.documentTypeSearch,
          nameOrCode: this.nameOrCode,
          customerName: this.customerName,
          status: this.status,
          serviceType: this.serviceType,
          taxCode: this.taxCode,
          createdUser: this.createdUser,
          createdTimeFrom: this.createdTimeFrom,
          createdTimeTo: this.createdTimeTo,
          finishDateFrom: this.finishDateFrom,
          finishDateTo: this.finishDateTo,
          pageView: true,
          sortColumn: this.sortColumn,
          sortDirection: this.sortDirection,
          signPage: this.document.signPage,
          goFrom: this.goFrom
        }
      });
    } else {
      this.dialogRef = this.dialog.open(ApprovalDocumentComponent, {
        width: '500px',
        data: {
          document: this.document
        }
      });
      this.dialogHandleAfterClose(this.dialogRef);
    }
  }

  openDialogRefuseApprovalDocument() {
    this.dialogRef = this.dialog.open(DeclineApproveDocumentComponent, {
      width: '500px',
      data: {
        document: this.document
      }
    });
    this.dialogHandleAfterClose(this.dialogRef);
  }

  openDialogRefuseSignDocument() {
    this.dialogRef = this.dialog.open(DeclineSignDocumentComponent, {
      width: '500px',
      data: {
        document: this.document
      }
    });
    this.dialogHandleAfterClose(this.dialogRef);
  }

  openDialogInitial() {

    this.dialogRef = this.dialog.open(InitialDialogComponent, {
      width: '550px',
      data: {
        id: this.document.id,
        name: null,
        isAutoSign: false,
        userSign: this.userSign,
        contractId: this.id
      }
    });
    this.dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.getDocumentById(this.id);
      }
    });
  }

  openDialogInitialSign() {
    this.dialogRef = this.dialog.open(InitialDialogSignComponent, {
      width: '750px',
      data: {
        id: this.document.id, name: null, isAutoSign: false
      }
    });
    this.dialogHandleAfterClose(this.dialogRef);
  }

  openDialogDeclineInitialSign() {
    this.dialogRef = this.dialog.open(DeclineInitialSignComponent, {
      width: '750px',
      data: {
        id: this.document.id, name: null, isAutoSign: false
      }
    });
    this.dialogHandleAfterClose(this.dialogRef);
  }

  onClickBackHistory() {
    this.location.go(this.location.path());
  }

  goBack() {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(['/home-enterprise/analysis-report']);
    }
  }

  gotoSignPage() {
    const signPage = this.document.signPage || 1;
    this.pageCurrent = signPage;
  }

  viewDocumentsUpload(id: string) {
    console.log("34354545 ====" + (new Date().toISOString()));
    return this.commonService.getViewPdfsForDocument(id).subscribe(async (res) => {
      console.log("start====" + (new Date().toISOString()));
      if (!res.data) {
        return;
      }
      const fileSrc = [];
      const files = [];
      for await (const [index, item] of res.data.entries()) {
        const file = new Blob([new Uint8Array(item.bytes)], {type: 'application/pdf'});
        files.push(file);
        const base64 = await this.blobToBinary(file);
        fileSrc.push(base64);
      }
      if (fileSrc.length > 0) {
        this.listFile = files;
        this.fileSrc = fileSrc;
        this.pdfSrc = fileSrc[this.activeFile];
      }
      console.log("end ====" + (new Date().toISOString()));
    });
  }

  blobToBinary(blob: Blob) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.onload = (e: any) => {
        resolve(e.target.result);
      };
      reader.readAsArrayBuffer(blob);
    })
  }

  changeFile(filePath: string, index) {
    this.pageCurrent = 1;
    this.activeFile = index;
    this.selectedFileSign =index;
    if (this.listPdfSrc) {
      // this.pdfSrc = this.fileSrc[index];
      this.pdfSrc = this.listPdfSrc[filePath];
    }
  }

  getStampWrapper(positionX: number, positionY: number, width: number, height: number, name: string, id: number, userId: any,fontSize?: any,fontFamily?:any,fontStyle?:any[],isContractCodeConfig = false) {
    const stampNode = document.createElement('div');
    if(!isContractCodeConfig) {
      stampNode.setAttribute('id', `sign-${id}-approver-${userId}`);
    } else {
      //neu la cau hinh ma hop dong
      stampNode.setAttribute('id', `${id}`);
    }
    let isTag = false;
    if (name && name.substring(0, 1) === '#' && name.substring(name.length - 1) === '#' && this.document.typeId === 0) {
      isTag = true;
    }
    const signatureWidth = width * this.zoomLevel / 100;
    const heightRectangle = height * this.zoomLevel / 100;

    const wrapperLeft = (positionX * this.zoomLevel) / 100;
    const wrapperTop = (positionY * this.zoomLevel) / 100;

    stampNode.style.position = 'absolute';
    stampNode.style.left = `${wrapperLeft}px`;
    stampNode.style.top = `${wrapperTop}px`;
    stampNode.style.width = `${signatureWidth}px`;
    stampNode.style.height = `${heightRectangle}px`;
    stampNode.style.background = 'rgb(0,0,0,0.2)';
    stampNode.style.zIndex = '1';
    stampNode.style.border = '1px solid #999999';
    stampNode.style.lineHeight = '1.9';
    stampNode.style.color = '#00f';
    stampNode.style.wordBreak = 'break-word';
    if(fontSize) {
      stampNode.style.fontSize = fontSize;
    };
    if(fontFamily) {
      stampNode.style.fontFamily = fontFamily;
    }else {
      stampNode.style.fontFamily = 'Roboto';
    };
    if(fontStyle &&fontStyle.includes('bold')) {
      stampNode.style.fontWeight = 'bold';
    }
    if(fontStyle &&fontStyle.includes('italic')) {
      stampNode.style.fontStyle = 'italic';
    }
    if(fontStyle &&fontStyle.includes('underline')) {
      stampNode.style.textDecoration = 'underline';
    }
    stampNode.style.padding = `${10 * this.zoomLevel / 100}px`;
    stampNode.className = 'no-user-select';
    if(isContractCodeConfig) {
      this.renderTextContent(stampNode, name, `font-size: ${(fontSize ? fontSize : 12) * (4 / 3) * (this.zoomLevel / 100)}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: move;`);
    } else {
      this.renderTextContent(stampNode, isTag ? name : this.message.getMessage('signature') + ' ' + name, `font-size: ${16 * this.zoomLevel / 100}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: ${heightRectangle - 2 * (10 * this.zoomLevel / 100)}px; color: #00f; cursor: move;`);
      if (isTag) {
        const content = stampNode.firstElementChild;
        const note = document.createElement('span');
        note.style.cssText = `font-size: ${12 * this.zoomLevel / 100}px; font-style: italic;`;
        note.textContent = this.message.getMessage('no_customer_for_sign');
        if (content) {
          content.appendChild(document.createElement('br'));
          content.appendChild(note);
        }
      }
      stampNode.style.fontWeight = 'bold';
    }

    stampNode.style.display = 'flex';
    stampNode.style.justifyContent = 'center';
    stampNode.style.flexDirection = 'column';
    stampNode.style.textAlign = 'center';

    return stampNode;
  }

  retry(){
    this.blockUI.reset();
    this.blockUI.start('');
    this.documentMohaService.retrySignFlow({contractId: this.document.id}).subscribe(
      res => {
        if(res && res.success){
          this.toastr.success(this.message.getMessage('digital_certificate_management.retry_success'));
          this.getDocumentById(this.document.id)
        }else{
          if(res.code === ErrorCode.NotEnoughMoneyTimestamp){
            this.dialog.open(NotifyWarningComponent, {
              data: this.message.getMessage('digital_certificate_management.retry_error')
            });
          }else if(res.code === ErrorCode.RetryExpiredMOIT){
            this.toastr.error(res.message);
            this.getDocumentById(this.document.id)
          }else
            this.toastr.error(res.message);
          this.blockUI.stop();
        }
      }
    )
  }

  signConfirmation() {
    this.dialogRef = this.dialog.open(SignatureProcessDialogComponent, {
      width: '550px',
      data: {
        id: this.document.id,
        name: null,
        isAutoSign: false,
        contractId: this.id
      }
    });
    this.dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.getDocumentById(this.id);
      }
    });
  }

  checkShowSignConfirmBtn(): boolean {
    const isUserAllowed = (this.document.userApproves || []).some(item => item.userId === this.userId && item.status == EnumContractUserStatus.PROCESSING);

    return this.isNotAttestedUser && this.document.status === EnumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT && isUserAllowed;
  }

  goToSignConfirmation() {
    this.router.navigate(['/home-enterprise/sign-confirm-document/' + this.id], {
      queryParams: {
        goFrom: 'viewDocument',
        flagCopy: true,
        page: this.page,
        pageSize: this.pageSize,
        routeLink: this.routeLink,
        enterprise: this.enterprise,
        documentType: this.documentTypeSearch,
        nameOrCode: this.nameOrCode,
        customerName: this.customerName,
        status: this.status,
        serviceType: this.serviceType,
        taxCode: this.taxCode,
        createdUser: this.createdUser,
        createdTimeFrom: this.createdTimeFrom,
        createdTimeTo: this.createdTimeTo,
        finishDateFrom: this.finishDateFrom,
        finishDateTo: this.finishDateTo,
        pageView: true,
        sortColumn: this.sortColumn,
        sortDirection: this.sortDirection,
        signPage: this.document.signPage,
      }
    });
  }

  /**
   * Hủy trình ký xác nhận
   */

  openDialogCancelSignConfirmation() {
    this.documentMohaService.getContractUserApprove(this.id).subscribe(rs => {
      if (!rs || !rs.data || rs.data.length === 0) {
        this.toastr.error(this.message.getMessage('cancel_sign_confirm.canceled_signature'));
        this.getDocumentById(this.id);
        return;
      }
      this.dialogRef = this.dialog.open(WarningCancelSignConfirmationComponent, {
        width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '750px',
        maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
        data: {
          contractId: this.id,
          contractUserApprove: rs.data,
          document: this.document
        }
      });
      this.dialogRef.afterClosed().subscribe(rs => {
        if (rs) {
          this.getDocumentById(this.id);
        }
      });
    });
  }

  /**
   * Trình ký xác nhận lại
   */

  reSignConfirmation() {
    this.documentMohaService.getContractUserApprove(this.id).subscribe(rs => {
      if (!rs || !rs.data || rs.data.length === 0) {
        this.toastr.error(this.message.getMessage('cancel_sign_confirm.resignature_error'));
        this.getDocumentById(this.id);
        return;
      }
      this.dialogRef = this.dialog.open(ReSignatureProcessDialogComponent, {
        width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '750px',
        maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
        data: {
          contractId: this.id,
          document: this.document,
          contractUserApprove: rs.data,
        }
      });
      this.dialogRef.afterClosed().subscribe(rs => {
        if (rs) {
          this.getDocumentById(this.id);
        }
      });
    });
  }
  returnToPrevPosition() {
    if (Object.keys(this.signSelected || {}).length) {
      const position = this.signSelected;
      const element = document.getElementById(`text-pdf-layer-${position.pageIndex}-${this.activeFile}`);
      const x = position.positionX;
      const y = position.positionY;
      const _width = position.widthRectangle;
      const _height = position.heightRectangle;
      const name = position.name;
      const id = position.enterpriseId || position.customerId;
      const userId = position.userId;
      const elWidth = element.offsetWidth;
      const elHeight = element.offsetHeight;
      const htmlNode = this.getStampWrapperNew(x, y, _width, _height, name, id, elWidth, elHeight, userId, null, null, [], false, (this.signSelected.idNumber || this.signSelected.contractSignId), this.signSelected.row_number);
      element.appendChild(htmlNode);
      this.signSelected = null;
      this.isSelectPosition = false;
      document.body.style.userSelect = 'none';
    }
  }
  onChangeZoom(event: any) {
    this.zoomLevel = 100;
    this.zoomLevel = event * 100;
  }
  onPagesLoaded(pagecount: PagesLoadedEvent): void {
    this.totalPage = pagecount.pagesCount;

  }
  getStampWrapperNew(positionX: number, positionY: number, width: number, height: number, name: string, id: number, elWidth: number, elHeight: number, idUser?: any, fontSize?: any, fontFamily?: any, fontStyle?: any[], isContractCodeConfig = false, uuid: string = '', row_number:any = '') {
    const stampNode = document.createElement('div');
    if (!isContractCodeConfig) {
      stampNode.setAttribute('id', `${uuid}-sign-${id}-approver-${idUser}`);
    } else {
      //neu la cau hinh ma hop dong
      stampNode.setAttribute('id', `${id}`);
    }


    let signatureWidth = width * this.zoomLevel / 100;
    let signatureHeight = height * this.zoomLevel / 100;

    const wrapperLeft = (positionX * this.zoomLevel) / 100;
    const wrapperTop = (positionY * this.zoomLevel) / 100;
    let signZoom = this.zoomLevel / 100;
    const widthHeightRatio = width / height;
    stampNode.style.position = 'absolute';
    stampNode.style.left = `${wrapperLeft}px`;
    stampNode.style.top = `${wrapperTop}px`;
    if (!isContractCodeConfig) {
      stampNode.style.width = `${signatureWidth}px`;
      stampNode.style.height = `${signatureHeight}px`;
      // stampNode.style.color = '#00f';
    }
    stampNode.style.minWidth = `calc(300px / 10 * 3 * ${this.zoomLevel / 100})`;
    stampNode.style.minHeight = `calc(136px / 10 * 3 * ${this.zoomLevel / 100})`;
    stampNode.style.background = 'rgb(0,0,0,0.2)';
    stampNode.style.zIndex = '1';
    stampNode.style.border = '1px solid #999999';
    stampNode.style.lineHeight = '1.9';
    stampNode.style.color = '#00f';

    if (fontSize) {
      stampNode.style.fontSize = fontSize;
    };
    if (fontFamily) {
      stampNode.style.fontFamily = fontFamily;
    } else {
      stampNode.style.fontFamily = 'Roboto';
    };
    if (fontStyle && fontStyle.includes('bold')) {
      stampNode.style.fontWeight = 'bold';
    }
    if (fontStyle && fontStyle.includes('italic')) {
      stampNode.style.fontStyle = 'italic';
    }
    if (fontStyle && fontStyle.includes('underline')) {
      stampNode.style.textDecoration = 'underline';
    }
    stampNode.style.padding = `${10 * signZoom}px`;
    stampNode.className = 'no-user-select';
    if (isContractCodeConfig) {
      stampNode.style.width = `${signatureWidth}px`;
      stampNode.style.height = `${signatureHeight}px`;
      if (this.documentCodeNull && !this.isOnAutoNumber) {
        stampNode.style.color = 'red';
      }
      // stampNode.style.whiteSpace = 'nowrap';
      // stampNode.style.minWidth ='fit-content';
      stampNode.style.wordBreak = 'break-word';
      if (this.documentCodeNull && !this.isOnAutoNumber) {
        const data ={
          userId:idUser
        }
        this.getOffClose(data);
        if(this.stopDrop){
          this.renderTextContent(stampNode, name, `font-size: ${(fontSize ? fontSize : 12) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; cursor: move;`, { closeIconSize: 30 * signZoom, contentClass: 'text-danger' });
        }
        else {
          this.renderTextContent(stampNode, name, `font-size: ${(fontSize ? fontSize : 12) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; cursor: move;`, { contentClass: 'text-danger' });
        }

      } else {
        const data ={
          userId:idUser
        }
        this.getOffClose(data);
        if(this.stopDrop){
          this.renderTextContent(stampNode, name, `font-size: ${(fontSize ? fontSize : 12) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
        }else{
          this.renderTextContent(stampNode, name, `font-size: ${(fontSize ? fontSize : 12) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: move;`);
        }
      }

    } else {
      const data ={
        userId:idUser
      }
      this.getOffClose(data);
      if(this.stopDrop){
        this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${name} ${this.message.getMessage('number_sign')} ${row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
      }else {
        this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${name}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`);
      }

      stampNode.style.display = 'flex';
      stampNode.style.justifyContent = 'center';
      stampNode.style.flexDirection = 'column';
      stampNode.style.textAlign = 'center';
      stampNode.style.fontWeight = 'bold';
    };
    //         Thay dổi kích thước chân ký

    const resizer = document.createElement('div');
    if(this.stopDrop){
      resizer.setAttribute('class', 'resize-div-bot-right');
    }
    // resizer.setAttribute('class', 'resize-div-bot-right');
    resizer.style.setProperty('--zoom', (signZoom).toString());
    stampNode.appendChild(resizer);
    let startX, startY, signId, userId, indexApprover, idSignature, signUuid;
    resizer.addEventListener('mousedown', (e) => {
      e.stopPropagation();
      startX = e.clientX;
      startY = e.clientY;
      document.documentElement.addEventListener('mousemove', doDrag);
      document.documentElement.addEventListener('mouseup', stopDrag);
      const targetSignId = e.target as Element;
      //la cau hinh ma hop dong
      if (isContractCodeConfig) {
        if (targetSignId.parentElement.id && targetSignId.parentElement.id.includes('contract-code-config-')) {
          idSignature = targetSignId.parentElement.id;
        }
      } else {
        indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
        const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
        signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
        userId = targetSignId.parentElement.id.slice(indexApprover + 10);
        signUuid = targetSignId.parentElement.id.slice(0, indexSign);
      }

    });

    let baseWidth = signatureWidth;
    let baseHeight = signatureHeight;

    const rerenderSign = () => {
      let signSelected, signatureSelected;
      if (this.listSignNew.length) {
        if (userId !== null && userId !== undefined && userId !== 'undefined') {
          signSelected = this.listSignNew.filter(item => (item.enterpriseId === signId || item.customerId === signId ) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
        } else {
          signSelected = this.listSignNew.filter(item => (item.enterpriseId === signId || item.customerId === signId && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId))));
        };
      } if (this.listSignature.length) {

        if (idSignature !== null && idSignature !== undefined && idSignature !== 'undefined') {
          signatureSelected = this.listSignature.filter(item => item.id == idSignature);
        };
      }
      if (isContractCodeConfig) {
        //   stampNode.style.whiteSpace = 'nowrap';
        //   stampNode.style.minWidth ='fit-content';
        const signSelected = this.listSignature.filter(item => item.id === id);
        stampNode.style.wordBreak = 'break-word';
        this.renderTextContent(stampNode, this.isOnAutoNumber ? this.configAutoNumber : this.document.code, `font-size: ${(fontSize === 12 ? signSelected[0].fontSize : fontSize) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
      } else {
        this.getOffClose(signSelected[0]);
        if(this.stopDrop){
          this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${signSelected[0].row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
        }
        else {
          this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${signSelected[0].name}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`);
        }

      }
      stampNode.appendChild(resizer);
      resizer.style.removeProperty('--zoom');
      resizer.style.setProperty('--zoom', (signZoom).toString());
      return;
    }

    const doDrag = (e) => {
      e.stopPropagation();
      let signSelected, signatureSelected;
      if (this.listSignNew.length) {
        if (userId !== null && userId !== undefined && userId !== 'undefined') {
          signSelected = this.listSignNew.filter(item => (item.enterpriseId === signId || item.customerId === signId ) && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
        } else {
          signSelected = this.listSignNew.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
        }
      } if (this.listSignature.length) {
        if (idSignature !== null && idSignature !== undefined && idSignature !== 'undefined') {
          signatureSelected = this.listSignature.filter(item => item.id == idSignature);
        };
      }
      //neu la cau hinh ma hop dong
      if (isContractCodeConfig) {
        signatureHeight = signatureSelected[0].heightRectangle * this.zoomLevel / 100;
        signatureWidth = signatureSelected[0].widthRectangle * this.zoomLevel / 100;
        stampNode.style.width = (signatureWidth + e.clientX - startX) + 'px';
        stampNode.style.height = (signatureHeight + e.clientY - startY) + 'px';
      } else {
        signatureHeight = signSelected[0].heightRectangle * this.zoomLevel / 100;
        signatureWidth = signSelected[0].widthRectangle * this.zoomLevel / 100;
        stampNode.style.width = (signatureWidth + e.clientX - startX) + 'px';
        stampNode.style.height = (signatureHeight + e.clientY - startY) + 'px';
        let widthHeightRatio_Drag = stampNode.offsetWidth / stampNode.offsetHeight;
        if (widthHeightRatio !== widthHeightRatio_Drag) {
          stampNode.style.height = (stampNode.offsetWidth / widthHeightRatio) + 'px';
          stampNode.style.width = (stampNode.offsetHeight * widthHeightRatio) + 'px';
        }
      }

      stampNode.style.maxWidth = (elWidth - stampNode.offsetLeft) + 'px';
      stampNode.style.maxHeight = (elHeight - stampNode.offsetTop) + 'px';

      rerenderSign();
    }

    const stopDrag = (e) => {
      e.stopPropagation();
      if (stampNode.offsetWidth / 2 + wrapperLeft < 0 || stampNode.offsetHeight / 2 + wrapperTop < 0) {
        stampNode.style.width = baseWidth + 'px';
        stampNode.style.height = baseHeight + 'px';
      } else {
        baseWidth = stampNode.offsetWidth;
        baseHeight = stampNode.offsetHeight;
      }

      rerenderSign();
      //neu la cau hinh ma hop dong
      if (isContractCodeConfig && this.listSignature) {
        this.listSignature.forEach(item => {
          if (item.id === idSignature) {
            item.widthRectangle = stampNode.offsetWidth * 100 / this.zoomLevel;
            item.heightRectangle = stampNode.offsetHeight * 100 / this.zoomLevel;
          }
        });
        // this.createContractMohaService.contractCodePositions.next(this.listSignature);
      } else if (this.listSignNew.length) {
        this.listSignNew.forEach(item => {
          if ((item.enterpriseId === signId || item.customerId === signId ) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId))) {
            item.widthRectangle = stampNode.offsetWidth * 100 / this.zoomLevel;
            item.heightRectangle = stampNode.offsetHeight * 100 / this.zoomLevel;
          }
        });
        // this.createContractMohaService.signPositions.next(this.listSign);
      }
      document.documentElement.removeEventListener('mousemove', doDrag);
      document.documentElement.removeEventListener('mouseup', stopDrag);
    }

    return stampNode;
  }
  cancel(){
    window.location.reload();
  }
  submitSign(){
    let message = '';
    const listData = this.listApproverSignAcount.filter(ele => ele.CTS && ele.showImage)
    if(listData.length > 0){
      this.listUserNoSign = listData.filter(ele => ! this.listSignNew.some(ala => ala.userId === ele.userId ));
    }
    else {
      this.listUserNoSign = [];
    }
    const listUser = this.listApproverSignAcount;
    const listSign = this.listSignNew;
    if(this.listUserNoSign.length > 0){
      message = this.message.getMessage('messages.confirm_TLLK');
      const confirmDialog = this.dialog.open(WarningComponent, {
        width: '700px',
        data: message
      });
      confirmDialog.afterClosed().subscribe(ref => {
        if (ref) {
          if(listSign.length >0){
            listUser.forEach(ele =>{
              const listData =[];
              listSign.forEach(ala =>{
                if(ele.userId == ala.userId){
                  listData.push(ala);
                  ele.positions = listData;
                }
              })
            })
          }
          listUser.forEach(element =>{
            if(element.positions && element.positions.length > 0){
              element.positions.forEach(ele =>{
                if(!ele.x){
                  ele.x = ele.positionX;
                }
                if(!ele.y){
                  ele.y = ele.positionY;
                }
                if(!ele.width){
                  ele.width = ele.widthRectangle;
                }
                if(!ele.height){
                  ele.height = ele.heightRectangle;
                }
                delete ele.userId;
                delete ele.enterpriseId;
              })
            }
          })
          const b = this.getCheckShowImage(this.document);
          listUser.forEach(ele =>{
            ele.isSignDigitalCertificate = ele.CTS ? ele.CTS:false;
            if(ele.CTS){
              ele.signConfig = !b ? '{"resize": false,"showImage":false}':(ele.showImage?'{"resize": false,"showImage":true}':'{"resize": false,"showImage":false}')
            }
            else {
              ele.signConfig = '{"resize": false,"showImage":false}';
            }

          })
          if(this.listUserNoSign.length >0){
            this.listUserNoSign.forEach(ele =>{
              listUser.forEach(ala =>{
                if(ele.userId == ala.userId){
                  ala.showImage = false;
                  ala.signConfig = '{"resize": false,"showImage":false}';
                }
              })
            })
          }
          let valueAddApprover = {
            contractId: this.document.id,
            userApproves: listUser
          }
          this.documentMohaService.addApproverContract(valueAddApprover).subscribe(res => {
            console.log('addApproverContractAnonymous', res)
            if (!res.success) {
              this.toastr.error(res.message);
              return
            } else {
              this.toastr.success(this.message.getMessage('approved.add_approver_success'));
              localStorage.removeItem('approvalToken');
              // Khi close dialog, load lại dữ liệu trang
              window.location.reload();
            }
          });
        }
      })
    }
    else {
      message = this.message.getMessage('messages.confirm_suscess_vanglai');
      const confirmDialog = this.dialog.open(WarningComponent, {
        width: '350px',
        data: message
      });
      confirmDialog.afterClosed().subscribe(ref => {
        if (ref) {
          if(listSign.length >0){
            listUser.forEach(ele =>{
              const listData =[];
              listSign.forEach(ala =>{
                if(ele.userId == ala.userId){
                  listData.push(ala);
                  ele.positions = listData;
                }
              })
            })
          }
          listUser.forEach(element =>{
            delete element.userId;
            delete element.enterpriseId;
            if(element.positions && element.positions.length > 0){
              element.positions.forEach(ele =>{
                if(!ele.x){
                  ele.x = ele.positionX;
                }
                if(!ele.y){
                  ele.y = ele.positionY;
                }
                if(!ele.width){
                  ele.width = ele.widthRectangle;
                }
                if(!ele.height){
                  ele.height = ele.heightRectangle;
                }
                delete ele.userId;
                delete ele.enterpriseId;
              })
            }
          })
          const b = this.getCheckShowImage(this.document);
          listUser.forEach(ele =>{
            ele.isSignDigitalCertificate = ele.CTS ? ele.CTS:false;
            if(ele.CTS){
              ele.signConfig = !b ? '{"resize": false,"showImage":false}':(ele.showImage?'{"resize": false,"showImage":true}':'{"resize": false,"showImage":false}')
            }
            else {
              ele.signConfig = '{"resize": false,"showImage":false}';
            }

          })
          let valueAddApprover = {
            contractId: this.document.id,
            userApproves: listUser
          }
          this.documentMohaService.addApproverContract(valueAddApprover).subscribe(res => {
            console.log('addApproverContractAnonymous', res)
            if (!res.success) {
              this.toastr.error(res.message);
              return
            } else {
              this.toastr.success(this.message.getMessage('approved.add_approver_success'));
              localStorage.removeItem('approvalToken');
              // Khi close dialog, load lại dữ liệu trang
              window.location.reload();
            }
          });
        }
      })
    }


  }
  getCheckShowImage(data){
    if(data.signConfig){
      return JSON.parse(data.signConfig).showImage;}
    else {
      return false;
    }
  }

  onAddApproverClick(data?){
    const checkAnhKy = this.getCheckShowImage(this.document);
    this.checkShowImage = this.getCheckShowImage(this.document);
    this.loadSign = false;
    this.dialogRef = this.dialog.open(AddApproverDialogComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '750px',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
      data: {
        hasLogin: true,
        document: this.document,
        data: this.listApproverSignAcount,
        check: data ? data : 2,
        checkAnhKy:checkAnhKy
      }
    });
    this.dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        if (rs) {
          this.checkTabPDF = false;
          this.checkEdit = false;
          rs.userApproves.forEach(ele => {
            ele.order = 1;
            // ele.userId = ele.email;
            ele.enterpriseId = 'KKDNKHVLKMDV';
            ele.name = ele.fullName
          })
          this.listApproverSignAcount = rs.userApproves;
          this.checkCTSShowImage = this.listApproverSignAcount.filter(ele => ele.CTS && ele.showImage);
          if (this.listSignNew.length > 0) {
            const dataPopup = this.listSignNew.filter(ele => !rs.userApproves.some(ala => ala.userId === ele.userId) && ele.userId);
            const dataChange = rs.userApproves.filter(ele => !ele.CTS || !ele.showImage);
            if(dataChange.length > 0){
              const dataChangeNew = this.listSignNew.filter(ele => dataChange.some(ala => ala.userId === ele.userId) && ele.userId);
              if(dataChangeNew.length > 0){
                for (var i = 0; i < dataChangeNew.length; i++) {
                  const userId = dataChangeNew[i].userId;
                  const enterpriseId = dataChangeNew[i].enterpriseId;
                  const signUuid = dataChangeNew[i].contractSignId || dataChangeNew[i].idNumber;
                  this.returnToPrevPosition();
                  const files = this.document.mainContractAttachments;
                  let id = dataChangeNew[i].fileId;
                  if (userId === undefined || userId === '' || userId === null || userId === 'undefined') {
                    // la khach hang ca nnhan
                    this.listSignNew = this.listSignNew.filter(sign => {
                      return (sign.enterpriseId !== enterpriseId && sign.customerId !== enterpriseId && sign.fileId === id) || sign.fileId !== id ||
                        ((sign.idNumber && signUuid != sign.idNumber) || (signUuid != sign.contractSignId && sign.contractSignId));
                    });
                  } else {
                    this.listSignNew = this.listSignNew.filter(sign => {
                      return (sign.userId !== userId && sign.fileId === id) || sign.fileId !== id || ((sign.idNumber && signUuid != sign.idNumber) || (signUuid != sign.contractSignId && sign.contractSignId));
                    });
                  }
                  // this.createContractMohaService.signPositions.next(this.listSign);
                  const nodeOther = document.getElementById(`${signUuid}-sign-${enterpriseId}-approver-${userId}`);

                  if (nodeOther) {
                    nodeOther.remove();
                  }
                  this.changeDataToTable()
                }
              }
            }
            if (dataPopup.length != 0) {
              for (var i = 0; i < dataPopup.length; i++) {
                // this.deleteSign(data[i].enterpriseId, data[i].userId, (data[i].contractSignId || data[i].idNumber))
                // enterpriseId: string, userId: string, signUuid
                const userId = dataPopup[i].userId;
                const enterpriseId = dataPopup[i].enterpriseId;
                const signUuid = dataPopup[i].contractSignId || dataPopup[i].idNumber;
                this.returnToPrevPosition();
                const files = this.document.mainContractAttachments;
                let id = dataPopup[i].fileId;
                if (userId === undefined || userId === '' || userId === null || userId === 'undefined') {
                  // la khach hang ca nnhan
                  this.listSignNew = this.listSignNew.filter(sign => {
                    return (sign.enterpriseId !== enterpriseId && sign.customerId !== enterpriseId && sign.fileId === id) || sign.fileId !== id ||
                      ((sign.idNumber && signUuid != sign.idNumber) || (signUuid != sign.contractSignId && sign.contractSignId));
                  });
                } else {
                  this.listSignNew = this.listSignNew.filter(sign => {
                    return (sign.userId !== userId && sign.fileId === id) || sign.fileId !== id || ((sign.idNumber && signUuid != sign.idNumber) || (signUuid != sign.contractSignId && sign.contractSignId));
                  });
                }
                // this.createContractMohaService.signPositions.next(this.listSign);
                const nodeOther = document.getElementById(`${signUuid}-sign-${enterpriseId}-approver-${userId}`);

                if (nodeOther) {
                  nodeOther.remove();
                }
                this.changeDataToTable()
              }
            }
          }
          if(this.listApproverSignAcount.length > 0 && this.listSignNew.length > 0){
            this.listSignNew.forEach(ele =>{
              this.listApproverSignAcount.forEach(ala => {
                if (ele.userId == ala.userId){
                  ele.name = ala.name
                  // ele.role = '1'
                }
              })
            })
          }

          this.changeDataToTable();
          // this.listDataPopupOld = rs;
          this.loadSign = true;
        }
      }
    });
  }

  changeDataToTable(){
    // this.listDataSign.enterprise.map(res=>{
    //   let changeDataUser = this.listSign.filter(sign => sign.userId == res.userId)
    //   this.tranformDataUser(changeDataUser)
    // })
    // this.listDataSign.customer.map(res=>{
    //   let changeDataCustomer = this.listSign.filter(sign => sign.customerId == res.customerId)
    //   this.tranformDataUser(changeDataCustomer)
    // })
    this.listApproverSignAcount.map(res=>{
      let changeDataApprover = this.listSignNew.filter(sign => sign.userId == res.userId)
      this.tranformDataUser(changeDataApprover)
    })
    // sortData
    this.listSignNew.sort((a, b) => a.positionX - b.positionX);
    this.listSignNew.sort((a, b) => a.positionY - b.positionY);
    this.listSignNew.sort((a, b) => a.pageIndex - b.pageIndex);
    // render lai khung chan ky
    this.listSignNew.map(res=>{
      console.log(res);
      let idSign = (res.contractSignId || res.idNumber) +  '-sign-' + (res.enterpriseId || res.customerId) + '-approver-' + res.userId
      let sign = document.getElementById(idSign)
      if (sign) {
        const elements = sign.getElementsByTagName('div');
        if (elements.length) {
          elements.item(0).textContent = `${this.message.getMessage('signature')} ${res.name} ${this.message.getMessage('number_sign')} ${res.row_number}`
        }
      }
    })
  }
  goToPage(enterpriseId: string, userId: string, signData) {
    this.returnToPrevPosition();
    const files = this.document.mainContractAttachments;
    let id;
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : null;
    }
    let idSign = signData.contractSignId || signData.idNumber
    const node = document.getElementById(`${idSign}-sign-${enterpriseId}-approver-${userId}`);
    const sign = this.listSignNew.find(sign => (sign.enterpriseId === enterpriseId || sign.customerId === enterpriseId) && sign.userId === userId && sign.fileId === id);
    this.pageIndex = sign ? sign.pageIndex : 1;
    if (node) {
      setTimeout(() => {
        node.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
      });
    } else {
      this.signNeedShow = sign.enterpriseId || sign.customerId;
      this.signApproverNeedShow = sign.userId;
    }
  }
  checkHaveSign(item: any, signData) {
    const files = this.document.mainContractAttachments;
    let id;
    let check;
    let idSign = signData.contractSignId || signData.idNumber
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : null;
    }
    if (item.enterpriseId) {
      check = this.listSignNew.find(sign =>
        (sign.enterpriseId === item.enterpriseId || sign.customerId === item.customerId) && sign.userId === item.userId && sign.fileId === id && (idSign === sign.contractSignId || idSign === sign.idNumber)
      );
      return check ? true : false;
    }
    check = this.listSignNew.find(sign =>
      sign.customerId === item.customerId && sign.userId === item.userId && sign.fileId === id && (idSign === sign.contractSignId || idSign === sign.idNumber)
    );
    return check ? true : false;
  }
  deleteSign(enterpriseId: string, userId: string, signUuid) {
    this.returnToPrevPosition();
    const files = this.document.mainContractAttachments;
    let id;
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : null;
    }
    if (userId === undefined || userId === '' || userId === null || userId === 'undefined') {
      // la khach hang ca nnhan
      this.listSignNew = this.listSignNew.filter(sign => {
        return (sign.enterpriseId !== enterpriseId && sign.customerId !== enterpriseId && sign.fileId === id) || sign.fileId !== id ||
          ((sign.idNumber && signUuid != sign.idNumber) || (signUuid != sign.contractSignId && sign.contractSignId));
      });
    } else {
      this.listSignNew = this.listSignNew.filter(sign => {
        return (sign.userId !== userId && sign.fileId === id) || sign.fileId !== id ||  ((sign.idNumber && signUuid != sign.idNumber) || (signUuid != sign.contractSignId && sign.contractSignId));
      });
    }
    // this.createContractMohaService.signPositions.next(this.listSign);
    const nodeOther = document.getElementById(`${signUuid}-sign-${enterpriseId}-approver-${userId}`);

    if (nodeOther) {
      nodeOther.remove();
    }
    this.changeDataToTable()
  }
  addSign(item: any) {
    // Lay so thu tu chan ky
    const idNumber = uuid.v4();
    // if(item.customerId){
    //   idNumber = this.listSign.filter(res=> res.customerId == item.customerId).length + 1
    // } else {
    //   idNumber = this.listSign.filter(res=> res.enterpriseId == item.enterpriseId).length + 1
    // }

    if (!this.pdfSrc) {
      if (!this.toastr.findDuplicate(this.message.getMessage('messages.error_contract'), true, true)) {
        this.toastr.error(this.message.getMessage('messages.error_contract'));
      }
      const listBtn = document.querySelectorAll("button");
      listBtn.forEach((btn) => {
        if (btn.className.includes('mat-stroked-button-create-document')) {
          btn.classList.add("btn_glowing");
        }
      });
      setTimeout(() => {
        listBtn.forEach((btn) => {
          btn.classList.remove("btn_glowing");
        });
      }, 5000);
      return;
    }
    // console.log(`text-pdf-layer-${this.pageIndex}-${this.activeFile}`);
    if (!document.getElementById(`text-pdf-layer-${this.pageIndex}-${this.activeFile}`)) {
      setTimeout(() => {
        this.addSign(item);
      }, 100);
      return;
    }
    this.returnToPrevPosition();
    if (!this.isSelectPosition) {
      const itemNew = JSON.parse(JSON.stringify(item));
      itemNew.idNumber = idNumber
      itemNew.row_number = 1
      const element: any = document.getElementById(`text-pdf-layer-${this.pageIndex}-${this.activeFile}`);
      const view: any = document.getElementById('viewerContainer');
      const elementBounding = element.getBoundingClientRect();
      const viewBounding = view.getBoundingClientRect();
      const offsetParent = element.offsetParent.dataset;
      const { pageNumber } = offsetParent;
      let signatureWidth = this.widthRectangle * this.zoomLevel / 100;
      let heightRectangle = this.heightRectangle * this.zoomLevel / 100;
      let signZoom = this.zoomLevel / 100;
      const widthHeightRatio = this.widthRectangle / this.heightRectangle;
      const wrapperLeft = 0;
      let wrapperTop = 0;
      if (viewBounding.y - elementBounding.y > heightRectangle) {
        wrapperTop = viewBounding.y - elementBounding.y;
      }
      const newDiv = document.createElement('div');
      // Sua Id chu ky

      newDiv.setAttribute('id', `${idNumber}-sign-${itemNew.enterpriseId || itemNew.customerId }-approver-${itemNew.userId}`);
      newDiv.style.left = `${wrapperLeft}px`;
      newDiv.style.top = `${wrapperTop}px`;
      newDiv.style.width = `${signatureWidth}px`;
      newDiv.style.height = `${heightRectangle}px`;
      newDiv.style.background = 'rgb(0,0,0,0.2)';
      newDiv.style.zIndex = '1';
      newDiv.style.border = '1px solid #999999';
      newDiv.style.lineHeight = '1.9';
      newDiv.style.color = '#00f';
      newDiv.style.fontFamily = 'Roboto';
      newDiv.style.padding = `${10 * signZoom}px`;
      newDiv.style.position = 'absolute';
      newDiv.style.minWidth = (300 / 10 * 3 * signZoom) + 'px';
      newDiv.style.minHeight = (136 / 10 * 3 * signZoom) + 'px';
      this.getOffClose(itemNew);
      if(this.stopDrop){
        this.renderTextContent(newDiv, `${this.message.getMessage('signature')} ${itemNew.name} ${this.message.getMessage('number_sign')} ${itemNew.row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
      }
      else {
        this.renderTextContent(newDiv, `${this.message.getMessage('signature')} ${itemNew.name}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`);
      }

      // <div class="resize-div-bot-right" style="--zoom: ${this.zoomLevel}"></div>
      newDiv.className = 'no-user-select';
      const zoomLevel = this.zoomLevel;
      itemNew.stampPositionLeft = 0;
      itemNew.stampPositionTop = 0;
      itemNew.positionX = 100 * wrapperLeft / zoomLevel;
      itemNew.positionY = 100 * wrapperTop / zoomLevel;
      itemNew.pageIndex = this.pageIndex;
      itemNew.zoom = this.zoomLevel / 100;
      itemNew.pdfSrc = this.pdfSrc;
      itemNew.pageNumber = pageNumber;
      itemNew.widthRectangle = this.widthRectangle;
      itemNew.heightRectangle = this.heightRectangle;
      const files = this.document.mainContractAttachments;
      let find;
      if (files && files.length && files[this.activeFile]) {
        const file = files[this.activeFile] as any;
        itemNew.fileId = file.id ? file.id : null;
        // Them nhieu chan ky
        // if (file) {
        //   if (item.enterpriseId) {
        //     find = this.listSign.find(sign => sign.fileId === file.id && sign.enterpriseId === item.enterpriseId && sign.userId === item.userId);
        //   } else {
        //     find = this.listSign.find(sign => sign.fileId === file.id &&  sign.customerId === item.customerId && sign.userId === item.userId);
        //   }
        // }
      }
      if (!find) {
        const resizer = document.createElement('div');
        if(this.stopDrop){
          resizer.setAttribute('class', 'resize-div-bot-right');
        }
        // resizer.setAttribute('class', 'resize-div-bot-right');
        resizer.style.setProperty('--zoom', signZoom.toString());
        newDiv.appendChild(resizer);
        element.appendChild(newDiv);

        let startX, startY;
        let signId;
        let userId;
        let indexApprover;
        let idNumber;
        let signUuid;
        resizer.addEventListener('mousedown', (e) => {
          e.stopPropagation();
          startX = e.clientX;
          startY = e.clientY;
          document.documentElement.addEventListener('mousemove', doDrag);
          document.documentElement.addEventListener('mouseup', stopDrag);
          const targetSignId = e.target as Element;
          indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
          const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
          signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
          userId = targetSignId.parentElement.id.slice(indexApprover + 10);
          signUuid = targetSignId.parentElement.id.slice(0, indexSign);

        });

        // const signSelected = this.listSign.filter(item => item.enterpriseId === signId);

        let baseWidth = newDiv.offsetWidth;
        let baseHeight = newDiv.offsetHeight;
        const rerenderSign = () => {
          const signSelected = this.listSignNew.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((signUuid === item.idNumber && item.idNumber) || (signUuid === item.contractSignId && item.contractSignId)));
          this.getOffClose(signSelected[0]);
          if(this.stopDrop){
            this.renderTextContent(newDiv, `${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${signSelected[0].row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
          }
          else {
            this.renderTextContent(newDiv, `${this.message.getMessage('signature')} ${signSelected[0].name}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`);
          }
          newDiv.appendChild(resizer);
          resizer.style.removeProperty('--zoom');
          resizer.style.setProperty('--zoom', (signZoom).toString());
          return;
        }

        const doDrag = (e) => {
          e.stopPropagation();
          const signSelected = this.listSignNew.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((signUuid === item.idNumber && item.idNumber) || (signUuid === item.contractSignId && item.contractSignId)));
          signatureWidth = signSelected[0].widthRectangle * this.zoomLevel / 100;
          heightRectangle = signSelected[0].heightRectangle * this.zoomLevel / 100;

          newDiv.style.width = (signatureWidth + e.clientX - startX) + 'px';
          newDiv.style.height = (signatureWidth + e.clientY - startY) + 'px';
          newDiv.style.maxWidth = (element.offsetWidth - wrapperLeft) + 'px';
          newDiv.style.maxHeight = (element.offsetHeight - wrapperTop) + 'px';
          let widthHeightRatio_Drag = newDiv.offsetWidth / newDiv.offsetHeight;
          if (widthHeightRatio !== widthHeightRatio_Drag) {
            newDiv.style.height = (newDiv.offsetWidth / widthHeightRatio) + 'px';
            newDiv.style.width = (newDiv.offsetHeight * widthHeightRatio) + 'px';
          }
          rerenderSign();
        }

        const stopDrag = (e) => {
          e.stopPropagation();
          if (newDiv.offsetWidth / 2 + wrapperLeft < 0 || newDiv.offsetHeight / 2 + wrapperTop < 0) {
            newDiv.style.width = baseWidth + 'px';
            newDiv.style.height = baseHeight + 'px';
          } else {
            baseWidth = newDiv.offsetWidth;
            baseHeight = newDiv.offsetHeight;
          }
          rerenderSign();

          this.listSignNew.forEach(item => {
            if ((item.enterpriseId === signId || item.customerId === signId) && ((signUuid === item.idNumber && item.idNumber) || (signUuid === item.contractSignId && item.contractSignId))) {
              item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
              item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
            }
          });
          // this.createContractMohaService.signPositions.next(this.listSign);
          document.documentElement.removeEventListener('mousemove', doDrag);
          document.documentElement.removeEventListener('mouseup', stopDrag);
        }

        this.listSignNew.push(itemNew);
        // this.createContractMohaService.signPositions.next(this.listSign);
        this.changeDataToTable()
      }
    }
  }
  changeFileAddSign(event: any, type?: string){
    this.documentCodeNull = (this.document.code.length == 0);
    let idx = 0;
    if (type && type == 'selectFileSign') {
      idx = event.value;
      this.selectedNumberPage = 1;
    } else {
      if (type == 'goToPage') {
        this.selectedNumberPage = null;
      }
      idx = event;
    }
    this.selectedFileSign = idx;
    this.pageIndex = 1;
    this.document.mainContractAttachments.forEach((file, index) => {
      if (file.fileName == this.fileUploads[idx].name) {
        this.activeFile = index;
      }
    });
    const file = this.document.mainContractAttachments;
    this.selectFile = this.fileUploads[idx];
    if (file.length) {

      this.pageIndex = 1;
      this.pageCurrent = 1;
      this.activeFile = idx;
      if (this.listPdfSrc) {
        // this.pdfSrc = this.fileSrc[index];
        this.pdfSrc = this.listPdfSrc[file[idx].path];
      }
    }
  }
  tranformDataUser(data){
    this.sortData(this.fileUploads,data)
    return data
  }
  sortData(listFile, listSignSort){
    const getFileIndex = (fileId: string): number => {
      return listFile.findIndex((file) => file.id === fileId);
    };

    const listSign: any[] = [];

    if (Array.isArray(listSignSort)) {
      listSign.push(...listSignSort);
    }

    listSign.sort((a, b) => a.positionX - b.positionX);
    listSign.sort((a, b) => a.positionY - b.positionY);
    listSign.sort((a, b) => a.pageIndex - b.pageIndex);

    listSign.sort((prev, next) => {
      return (
        getFileIndex(prev.fileId) - getFileIndex(next.fileId)
      );
    });
    this.fileUploads = this.document.mainContractAttachments;
    this.fileUploads.map((res: any)=>{
      let signFile = listSign.filter(sign => sign.fileId == res.id)
      signFile.forEach((row, index) =>{
        row.row_number = index +1;
      });
    })
    return listSign;
  }
  onForwardSignClick(){
    this.dialogRef = this.dialog.open(ForwardSignDialogComponent, {
      width: '550px',
      data: {
        id: this.document.id,
        name: null,
        isAutoSign: false,
        userSign: this.userSign,
        contractId: this.id
      }
    });
    this.dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.getDocumentById(this.id);
      }
    });
  }

  checkPermissionCreateContract() {
    if(this.commonService.checkDefaultAdmin()) {
      return true;
    }
    if(this.permissions.includes(12)) {
      return true;
    }
    return false;
  }

  isString(value) {
    return typeof value === "string";
  }

  openViewProperties(){
    let customerSign = this.enterpriseSign.find((customer: any) => customer.customerType == 10000 && customer.customerId == this.customerMohaId)
    const dialogComponent: any = this.document.formType === 'CONTRACT_APPENDIX'
      ? ViewPropertiesDialogComponent
      : ViewPropertiesOriginalDialogComponent;
    this.dialogRef = this.dialog.open(dialogComponent, {
      width: '80vw',
      data: {
        isPermissionProperties: this.permissions.includes(FeatureGroup.STANDARDIZATION_EMPLOYMENT_CONTRACT),
        isVneidVerified: this.isVneidVerified,
        canEdit: this.isEditMode,
        contractId: this.id,
        listDataSource: this.listDataSource,
        listDataUpdateSource: this.listDataUpdateSource,
        customerMohaId: this.customerMohaId,
        customerMohaName: (customerSign && customerSign.enterpriseName) ? customerSign.enterpriseName : '',
        listCustomer: this.listCustomer,
        optionsMap: this.optionsMap,
        isOriginalContract: this.document.formType === 'CONTRACT_APPENDIX' ? true : false,
        titleChange: this.titleChange,
        listColumnVersionHistory: this.document.formType === 'CONTRACT_APPENDIX' ? [] : this.listColumnVersionHistory,
        listDataVersionHistory: this.document.formType === 'CONTRACT_APPENDIX' ? [] : this.listDataVersionHistory,
      }
    });
    this.dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.getDocumentById(this.id);
      }
    });
  }

  async loadDataTable() {
    let dataApi = await this.documentTypeService.getInfoProperties(null, false).toPromise()
    if (!dataApi || !dataApi.data) {
      return;
    }
    let res:any = dataApi.data
    let listProperties = this.mapDataMergeField(res)
    this.listDataSource = listProperties;
    this.buildOptions('ADD')
  }

  private buildOptions(type: string) {
    if (type === 'ADD') {
      this.listDataSource.forEach((item: any) => {
        if(item.inputType == "DROPDOWN" && item.metadata){
          this.optionsMap.set(
            item.id,
            JSON.parse(item.metadata)
          );
        }
      });
    } else {
      this.listDataUpdateSource.forEach((item: any) => {
        if(item.inputType == "DROPDOWN" && item.metadata){
          this.optionsMap.set(
            item.id,
            JSON.parse(item.metadata)
          );
        }
      });
    }

  }

  mapDataMergeField(data: any){
    if(!data || !data.length) return
    let dataPropertiesConvert = []
    data.forEach((field: any, idx: number) => {
      let propertiesInfo: any = {
        ...field,
        stt: idx + 1,
        dataDropDown: [],
        controlField: field.isRequired ? new FormControl('', [Validators.required]) : new FormControl()
      }
      propertiesInfo.controlField.disable()
      dataPropertiesConvert.push(propertiesInfo)
    });
    return dataPropertiesConvert
  }

  mappingDataMFFormService(dataMF: any, type: string){
    if(dataMF && Array.isArray(dataMF) && dataMF.length){
      dataMF.forEach((mfData: any) => {
        if (type === 'ADD') {
          let existMFInTableIdx = this.listDataSource.findIndex((row: any) => row.code == mfData.key)
          if(existMFInTableIdx >= 0 && this.listDataSource[existMFInTableIdx] && this.listDataSource[existMFInTableIdx].controlField){
            if(mfData.value){
              this.listDataSource[existMFInTableIdx].controlField.patchValue(mfData.value)
            }
          }
        } else {
          let existMFInTableIdx = this.listDataUpdateSource.findIndex((row: any) => row.code == mfData.key)
          if(existMFInTableIdx >= 0 && this.listDataUpdateSource[existMFInTableIdx] && this.listDataUpdateSource[existMFInTableIdx].controlField){
            if(mfData.value){
              this.listDataUpdateSource[existMFInTableIdx].controlField.patchValue(mfData.value)
            }
          }
        }
      })
    }
  }

  handleShowBtnReport(){
    this.isShowBtnReport = this.document.enterpriseId == this.enterpriseId && (!this.isContractStandardized || this.isContractStandardized && this.isShowBtnViewReport)
  }

  checkTindy(callback?: () => void){
    this.contractService.checkTindyUser().subscribe(ref => {
      if(!ref.success){
        this.toastr.error(ref.message);
        return;
      }
      if(ref.data == 0 || ref.data == 2 ){
         //Popup anthention data
          let message = "";
         if(ref.data == 2){
         message = this.message.getMessage('notifyTindy.notify');
         }else if(ref.data == 0){
         message = this.message.getMessage('notifyTindy.notify_2')
         }
        const confirmDialog = this.dialog.open(WarningDataAuthenticationComponent, {
        width: '469px',
        height: '348px',
        data: {
          message,
          statusDocument: this.document.status
        }
         });
         confirmDialog.afterClosed().subscribe(ref => {
          if (ref) {
            this.dialog.open(SignAuthenticationPopupComponent, {
            panelClass: 'sign-authentication',
            width: '791px',
            height: 'auto',
            data: {
              message,
              statusDocument: this.document.status
            }
          });
          }
       });
      }else if(ref.data == 1){
        if(callback) callback();
      }
    })
  }

  checkTindySign() {
    if (this.userId && this.isEmploymentContract) {
      const approverFilter = this.userSign.find((rs) => rs.userId === this.userId);
      if (approverFilter) {
        if (approverFilter.role == 2 && approverFilter.isSignDigitalCertificate || approverFilter.role == 1) {
          this.checkTindy();
        }
      } else {
        if (this.document.status == 4 && this.document.createdBy === localStorage.getItem('userId')) {
          this.checkTindy();
        }
      }
    }
  }

  private renderTextContent(container: HTMLElement, text: unknown, contentStyle: string, options?: { closeIconSize?: number; contentClass?: string; notification?: { text: unknown; style: string } }): void {
    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }
    if (options && options.closeIconSize !== undefined) {
      const closeIcon = document.createElement('span');
      closeIcon.className = 'mat-icon material-icons';
      closeIcon.style.cssText = `font-size: ${options.closeIconSize}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;`;
      closeIcon.textContent = 'close';
      container.appendChild(closeIcon);
    }
    const content = document.createElement('div');
    content.style.cssText = contentStyle;
    if (options && options.contentClass) {
      content.className = options.contentClass;
    }
    if (options && options.notification) {
      const notification = document.createElement('div');
      notification.id = 'notify_outside';
      notification.style.cssText = options.notification.style;
      notification.textContent = String(options.notification.text == null ? '' : options.notification.text);
      content.appendChild(notification);
    }
    content.appendChild(document.createTextNode(String(text == null ? '' : text)));
    container.appendChild(content);
  }

  protected readonly print = print;
}
